import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef, HostListener, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, FormControl, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, FormGroup } from '@angular/forms';
import { Location } from '@angular/common'
import { interval, merge, Subscription, Observable, forkJoin, of } from 'rxjs';
import { take, debounceTime, distinctUntilChanged, finalize, catchError, map } from 'rxjs/operators';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { ReportsService } from '../../services/reports.service';
import { PaymentsService } from '../../services/payments.service';
import { VendorService } from '../../services/vendor.service';
import { CustomerService } from '../../services/customer.service';
import { OrdersService } from '../../services/orders.service';
import { PrintService } from '../../services/print.service'
import { GeneralLedgerService } from '../../services/general-ledger.service';
import { UsersService } from '../../services/users.service'
import * as FileSaver from 'file-saver';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material/dialog';
import {
	SlimJournalEntryDialogComponent,
	SlimJournalEntryDialogData,
} from '../slim-journal-entry-dialog/slim-journal-entry-dialog.component';
import { CustomerAccountOverviewModalComponent } from '../../shared/customer-account-overview-modal/customer-account-overview-modal.component';


@Component({
	selector: 'app-bank-rec',
	templateUrl: './bank-rec.component.html',
	styleUrls: ['./bank-rec.component.scss']
})
export class BankRecComponent implements OnInit, OnDestroy {
	config: any = false;
	color = 'blue';
	payment_methods: any = [];
	today = new Date();
	dateto = new UntypedFormControl(this.today);
	datefrom = new UntypedFormControl(this.getFirstDayOfLastMonth());
	ref_location: any;
	user: any = [];
	isPosUser = false;
	locations: any = [];
	transactions: any = [];
	salespeople: any = [];
	title = 'Bank Reconciliation';
	defaultlocation = new UntypedFormControl('');
	searchFilter = new FormControl('');
	salesperson = new UntypedFormControl('');
	paymenttypefilter = new UntypedFormControl();
	/**
	 * Server-facing ledger scope ('ar' | 'ap' | 'both') — derived from arapLedgers,
	 * never bound directly. Kept scalar because that is the apir contract.
	 */
	arapMode = new UntypedFormControl('both');
	/**
	 * What the Ledger picker binds to. Defaults to BOTH: a bank account is not an AR
	 * or an AP thing, and defaulting to receipts-only hid every payment on the account
	 * along with whether it had cleared.
	 */
	arapLedgers = new UntypedFormControl(['ar', 'ap']);
	showCleared = new UntypedFormControl(true);
	orignal_results: any = {};
	running = false;
	lockingAllCleared = false;
	unlockingAllLocked = false;
	payments: any = [];
	total_pay: any = 0;
	total_sub: any = 0;
	cctotal: any = 0;
	total_discount: any = 0;
	filteredTransactions: any = [];
	temporaryAmount = new UntypedFormControl('');
	bankAccounts: any = [];
	selectedBankAccount = new UntypedFormControl('');
	statementBalance = new UntypedFormControl(0);
	clearedTotal = 0;
	variance = 0;
	glBookBalance: number | null = null;
	glBookPeriod: number | null = null;
	glBookLoadError = false;
	private glBookRequestSeq = 0;
	private glBookRefreshSub?: Subscription;
	private readonly statementStorageKeyVersion = 'bankRecStmtBal_v1';
	private prevBankForStatement = '';
	private statementPersistSub?: Subscription;
	private bankSwitchSub?: Subscription;
	private statementVarianceSub?: Subscription;
	private filterReloadSub?: Subscription;
	groupedView = true;
	groupedTransactions: Array<{
		date: string;
		dateFmt: string;
		expanded: boolean;
		allCleared: boolean;
		partiallyCleared: boolean;
		total: number;
		types: Array<{
			type: string;
			allCleared: boolean;
			partiallyCleared: boolean;
			total: number;
			detailExpanded: boolean;
			transactions: any[];
		}>;
	}> = [];


	// --- Bank Feed = matching workspace only. Connections = SimpleFIN connect/mapping.
	// Statement Files = dropping a downloaded statement + its history. Batch match =
	// N ERP rows settling ONE bank line. All feed the same bank_feed_transactions,
	// split by what each is actually for. ---
	activeTab: 'rec' | 'integrations' | 'ar' | 'connections' | 'files' | 'groups' = 'rec';
	/**
	 * Batch match ("Batch match" tab). Where the ERP records every receipt
	 * individually and the bank shows one lumped deposit, 1:1 matching can never
	 * work — the server proposes which SET of ERP rows makes up each bank line and
	 * this holds the review state for accepting them.
	 */
	grp: {
		bankaccount: string; loading: boolean; savingSettings: boolean;
		proposals: any[]; poolSize: number; poolWindow: string[]; counts: any;
		settings: any; tenderTypes: any[]; message: string; loaded: boolean;
		onlyTies: boolean; expanded: { [key: string]: boolean }; matching: { [key: string]: boolean };
		newTenderLabel: string; newTenderTypes: string[];
		newVarType: string; newVarAmount: number | null;
	} = {
			bankaccount: '', loading: false, savingSettings: false,
			proposals: [], poolSize: 0, poolWindow: [], counts: { lines: 0, withGroups: 0 },
			settings: null, tenderTypes: [], message: '', loaded: false,
			onlyTies: true, expanded: {}, matching: {},
			newTenderLabel: '', newTenderTypes: [],
			newVarType: '', newVarAmount: null,
		};
	/** Progress of the "match all exact ties" pass, so the button can show N of M. */
	grpBulk: { running: boolean; done: number; total: number; failed: number } =
		{ running: false, done: 0, total: 0, failed: 0 };
	/** Off-screen table the feed exports are rendered from. */
	@ViewChild('sfFeedPrint') sfFeedPrint: ElementRef;
	/**
	 * Gates the export table into the DOM. It is built ON DEMAND rather than kept
	 * rendered: "All rows" is 500+ feed rows, and a permanently-mounted copy would
	 * re-run sfBankRows() and re-render all of them on every change-detection pass.
	 */
	sfPrintReady = false;
	/** '' | 'xlsx' | 'pdf' — which export is in flight, so both buttons disable. */
	sfExporting: '' | 'xlsx' | 'pdf' = '';
	// Auto-match tolerance: bank posting can lag the ERP date by a few days.
	private readonly SF_MATCH_DAYS = 5;
	sfMatching = false;
	sfAiMatching = false;
	sfFeedLoading = false;
	sfErpLoading = false;
	sfSavingMap = false;
	sfExpanded = false;
	sfPostingRow: any = null;
	sfPostingMode: 'find' | 'new' | 'invoice' | 'payment' = 'find';
	sfVendorSearch = '';
	sfVendorResults: any[] = [];
	sfPostingVendor: any = null;
	sfVendorLoading = false;
	// Money-in: post a customer receipt straight from an unmatched bank deposit.
	sfReceiptRow: any = null;
	sfReceiptSearch = '';
	/** Set when the typed search found nothing and a narrower word was tried instead. */
	sfReceiptSearchFallback = '';
	sfReceiptResults: any[] = [];
	sfReceiptLoading = false;
	sfReceiptCustomer: any = null;
	sfReceiptAr: any = null; // AR snapshot for the selected customer (balance, currcode)
	sfReceiptPaymentType: any = '';
	sfReceiptReference = '';
	sfReceiptSubmitting = false;
	private sfReceiptSearchSub: Subscription | null = null;
	// After posting a receipt, pair the feed row to the freshly created ERP row.
	private sfPendingPairRow: any = null;
	private sfArRefreshTimer: any = null;
	/** Feed rows whose receipts were just batch-posted, awaiting bank-line pairing. */
	private sfPendingPairRows: any[] = [];
	/** AR automation: proposals over unmatched deposits (ready / review / unresolved). */
	sfAr: {
		loading: boolean; loaded: boolean; posting: boolean;
		ready: any[]; review: any[]; attention: any[]; unresolved: any[]; nonCustomer: any[];
		counts: { ready: number; review: number; attention: number; unresolved: number;
			nonCustomer?: number } | null;
		done: number; total: number; posted: number; failed: number;
		resolving: boolean; resolveDone: number; resolveTotal: number;
		reviewOpen: boolean; attentionOpen: boolean; unresolvedOpen: boolean;
		nonCustomerOpen: boolean; message: string;
	} = {
			loading: false, loaded: false, posting: false,
			ready: [], review: [], attention: [], unresolved: [], nonCustomer: [], counts: null,
			done: 0, total: 0, posted: 0, failed: 0,
			resolving: false, resolveDone: 0, resolveTotal: 0,
			reviewOpen: false, attentionOpen: false, unresolvedOpen: false,
			nonCustomerOpen: false, message: ''
		};
	/* The check log — payments known before they reach the bank. Unlike every other
	   pane here this one is NOT sourced from the feed; it is what the bookkeeper
	   wrote down, and it is the only thing that can name the customer on a
	   nameless mobile-check deposit. */
	sfLog: {
		loading: boolean; loaded: boolean; saving: boolean; open: boolean;
		rows: any[]; draft: any | null; message: string;
		posting: boolean; postTotal: number; postDone: number; doneOpen: boolean;
		// Open by default: the drop zone is the entry point for the whole check-log
		// flow, and a collapsed section reads as "the feature isn't there". The DONE
		// section is the opposite — finished work is the bulk of the list over time and
		// pushes the two states that still want something off the screen.
	} = { loading: false, loaded: false, saving: false, open: true, rows: [], draft: null, message: '',
		posting: false, postTotal: 0, postDone: 0, doneOpen: false };
	/* Photo intake for the log page. Held separate from sfLog because these rows are
	   a PROPOSAL — nothing exists in the database until the operator ticks and saves. */
	sfShot: {
		over: boolean; reading: boolean; saving: boolean; fileName: string;
		rows: any[]; counts: { rows: number; clean: number; flagged: number } | null;
		total: number; depositDate: string; message: string;
	} = { over: false, reading: false, saving: false, fileName: '', rows: [], counts: null, total: 0, depositDate: '', message: '' };
	private sfAfterErpLoad: (() => void) | null = null;
	// Side-by-side workspace: pane filters, cross-highlighting, click-to-pair.
	sfStatusFilter: 'all' | 'unmatched' | 'matched' | 'ignored' = 'unmatched';
	sfBankSearch = '';
	sfErpSearch = '';
	sfSubsetFrom = '';
	sfSubsetTo = '';
	sfAmountOccurrence: 'all' | 'single' | 'repeated' = 'all';
	sfDirection: 'all' | 'in' | 'out' = 'all';
	sfSort: 'date-desc' | 'date-asc' | 'amount-desc' | 'amount-asc' | 'name' = 'date-desc';
	sfSelectedBank: any = null; // unmatched bank row awaiting an ERP pick
	// Group matching: several bank lines ↔ one ERP posting (or one bank ↔ several ERP).
	sfSelBank: any[] = []; // multi-selected bank rows (checkboxes)
	sfSelErp: any[] = []; // multi-selected ERP candidates inside the match modal
	sfHoverFeed: any = null; // hovered matched feed row — lights up ALL its ERP partners
	@ViewChild('sfMatchModal') sfMatchModal?: TemplateRef<any>;
	private sfMatchModalRef?: NgbModalRef;
	sfMatchExpanded = false;
	sfCandidateSearch = '';
	sfCandidateKind: 'all' | 'exact' | 'name' | 'any' = 'all';
	sfCandidateDays = 0;
	sfCandidateSort: 'recommended' | 'closest' | 'amount' | 'name' = 'recommended';
	sfHoverLink = 0; // banktransid of the hovered/jumped matched pair — lights up both sides
	sfRevealLink = 0; // linked row temporarily revealed without changing the operator's filters
	private sfMatchIdx: { [banktransid: number]: any } = {};
	private sfInternalReversalIds = new Set<number>();
	sf: {
		loaded: boolean; connected: boolean; token: string;
		claiming: boolean; syncing: boolean; loadingAccounts: boolean;
		accounts: any[]; accountMap: { [sfId: string]: string }; bankAccounts: any[];
		transactions: any[]; errors: any[]; message: string; manageUrl: string;
		lastImport: { at: number; new: number; updated: number; total: number; start: string; end: string } | null;
	} = {
			loaded: false, connected: false, token: '',
			claiming: false, syncing: false, loadingAccounts: false,
			accounts: [], accountMap: {}, bankAccounts: [], transactions: [], errors: [], message: '', manageUrl: '',
			lastImport: null
		};
	/** Quick history windows for the bank import (days back from today). */
	readonly sfImportWindows = [30, 90, 180, 365];

	constructor(
		private generalLedgerService: GeneralLedgerService,
		private ordersService: OrdersService,
		private usersService: UsersService,
		private _changeDetectorRef: ChangeDetectorRef,
		private location: Location,
		private reportsService: ReportsService,
		private printService: PrintService,
		private globalSearchService: GlobalSearchService,
		private globalsService: GlobalsService,
		private paymentsService: PaymentsService,
		private vendorService: VendorService,
		private customerService: CustomerService,
		private fb: UntypedFormBuilder,
		private route: ActivatedRoute,
		public router: Router,
		private modalService: NgbModal,
		private dialog: MatDialog
	) {
		this.searchFilter.valueChanges.subscribe(() => {
			this.applyFilters();
		});

		// Warehouse / Type narrow the loaded list instantly, then re-query the
		// server (debounced) so the dataset scope follows the new filters too —
		// same pattern as the AR/AP ledger selector.
		this.defaultlocation.valueChanges.subscribe(() => this.applyFilters());
		this.paymenttypefilter.valueChanges.subscribe(() => this.applyFilters());
		// Ledger is driven off valueChanges, not (selectionChange): the appSelectAll
		// directive assigns MatSelect.value directly, which updates the control without
		// emitting selectionChange — so Select All/None would silently not re-query.
		this.arapLedgers.valueChanges.subscribe(() => this.onArapModeChange());
		this.filterReloadSub = merge(this.defaultlocation.valueChanges, this.paymenttypefilter.valueChanges)
			.pipe(
				debounceTime(700),
				map(() => JSON.stringify({
					l: this.defaultlocation.value,
					t: Array.isArray(this.paymenttypefilter.value) ? this.paymenttypefilter.value.map((m: any) => m?.paymentid) : this.paymenttypefilter.value,
				})),
				distinctUntilChanged()
			)
			.subscribe(() => {
				if (this.payments && this.selectedBankAccount.value && !this.running) {
					this.loadTransactions();
				}
			});

		this.subscribeToGlobalUpdates();

		this.statementPersistSub = this.statementBalance.valueChanges
			.pipe(debounceTime(600), distinctUntilChanged((a, b) => String(a) === String(b)))
			.subscribe(() => {
				const ac = this.selectedBankAccount.value;
				if (ac) {
					this.persistStatementBalanceForAccount(String(ac));
				}
			});

		this.bankSwitchSub = this.selectedBankAccount.valueChanges.subscribe((ac) => {
			if (this.prevBankForStatement) {
				this.persistStatementBalanceForAccount(this.prevBankForStatement);
			}
			this.prevBankForStatement = ac ? String(ac) : '';
			if (ac) {
				this.restoreStatementBalanceForAccount(String(ac));
			}
			this.refreshGlBookBalance();
		});
	}

	ngOnDestroy(): void {
		this.statementPersistSub?.unsubscribe();
		this.bankSwitchSub?.unsubscribe();
		this.statementVarianceSub?.unsubscribe();
		this.glBookRefreshSub?.unsubscribe();
		this.filterReloadSub?.unsubscribe();
	}

	private getUserIdForStorage(): string {
		const gu = this.globalsService?.user?.user?.userid ?? this.globalsService?.user?.userid;
		const u = gu ?? this.user?.user?.userid ?? this.user?.userid;
		const s = u != null ? String(u).trim() : '';
		return s !== '' ? s : 'anonymous';
	}

	private readStatementBalanceMap(): Record<string, number> {
		try {
			const raw = localStorage.getItem(`${this.statementStorageKeyVersion}_${this.getUserIdForStorage()}`);
			if (!raw) {
				return {};
			}
			const parsed = JSON.parse(raw);
			return parsed && typeof parsed === 'object' ? parsed : {};
		} catch {
			return {};
		}
	}

	private writeStatementBalanceMap(map: Record<string, number>): void {
		try {
			localStorage.setItem(`${this.statementStorageKeyVersion}_${this.getUserIdForStorage()}`, JSON.stringify(map));
		} catch {
			/* ignore quota / private mode */
		}
	}

	private persistStatementBalanceForAccount(accountCode: string): void {
		if (!accountCode) {
			return;
		}
		const map = this.readStatementBalanceMap();
		const v = parseFloat(String(this.statementBalance.value));
		map[accountCode] = Number.isFinite(v) ? v : 0;
		this.writeStatementBalanceMap(map);
	}

	private restoreStatementBalanceForAccount(accountCode: string): void {
		const map = this.readStatementBalanceMap();
		const raw = map[accountCode];
		const v = raw != null && Number.isFinite(Number(raw)) ? Number(raw) : 0;
		this.statementBalance.setValue(v, { emitEvent: false });
		this.calculateVariance();
	}

	applyFilters() {
		if (this.payments && this.payments.transactions) {
			this.payments.transactions.forEach((t: any) => this.normalizeClearedLockedFlag(t));
			const searchValue = this.searchFilter.value?.toLowerCase() || '';

			// Warehouse / Type only constrain when a strict subset is selected;
			// rows missing the attribute pass (AP lines may carry no location).
			const locCodes: string[] = Array.isArray(this.defaultlocation.value) ? this.defaultlocation.value.map((l: any) => String(l)) : [];
			const locActive = locCodes.length > 0 && locCodes.length < (this.locations?.length || 0);
			const typeNames: string[] = Array.isArray(this.paymenttypefilter?.value) ?
				this.paymenttypefilter.value.map((m: any) => String(m?.paymentname || '').toLowerCase()).filter((n: string) => n !== '') : [];
			const typeActive = typeNames.length > 0 && typeNames.length < (this.payment_methods?.length || 0);

			if (this.arapNoneSelected) {
				this.filteredTransactions = [];
				// Grouped view reads its own array — clear it too or it keeps the
				// previous selection's rows on screen.
				if (this.groupedView) { this.buildGroupedView(); }
				this.calculateVariance();
				return;
			}

			this.filteredTransactions = this.payments.transactions.filter((transaction) => {
				if (!this.showCleared.value && transaction.isCleared) {
					return false;
				}

				if (locActive) {
					const loc = transaction.paylocation != null ? String(transaction.paylocation) : '';
					if (loc !== '' && locCodes.indexOf(loc) === -1) {
						return false;
					}
				}

				if (typeActive) {
					const ttype = String(transaction.banktranstype || '').toLowerCase();
					if (ttype !== '' && typeNames.indexOf(ttype) === -1) {
						return false;
					}
				}

				if (searchValue) {
					const fieldsToSearch = [
						'transno',
						'debtorno',
						'reference',
						'name',
						'ovamount',
						'checknum',
						'banktranstype',
						'placedby'
					];

					const matchesSearch = fieldsToSearch.some((field) => {
						const value = transaction[field];
						return (
							value !== null &&
							value !== undefined &&
							value.toString().toLowerCase().includes(searchValue)
						);
					});

					return matchesSearch;
				}

				return true;
			});

			if (this.groupedView) {
				this.buildGroupedView();
			}

			this.calculateVariance();
		}
	}

	buildGroupedView(): void {
		const prevUi = new Map<string, { dateExpanded: boolean; types: Map<string, boolean> }>();
		this.groupedTransactions.forEach((dg) => {
			const tm = new Map<string, boolean>();
			dg.types.forEach((tg) => tm.set(tg.type, !!tg.detailExpanded));
			prevUi.set(dg.date, { dateExpanded: !!dg.expanded, types: tm });
		});

		const grouped = new Map<string, Map<string, any[]>>();

		this.filteredTransactions.forEach((trans: any) => {
			const date = trans.trandate || '';
			const type = trans.banktranstype || 'Unknown';

			if (!grouped.has(date)) {
				grouped.set(date, new Map());
			}

			const dateGroup = grouped.get(date)!;
			if (!dateGroup.has(type)) {
				dateGroup.set(type, []);
			}

			dateGroup.get(type)!.push(trans);
		});

		this.groupedTransactions = [];
		grouped.forEach((typeMap, date) => {
			const types: any[] = [];
			let dateTotal = 0;
			const dateTransactions: any[] = [];

			typeMap.forEach((transactions, type) => {
				const typeTotal = transactions.reduce((sum, t) => sum + (parseFloat(t.amount) || 0), 0);
				const typeAllCleared = transactions.length > 0 && transactions.every((t) => this.isTransactionCleared(t));
				const typeAnyCleared = transactions.some((t) => this.isTransactionCleared(t));
				const typePartiallyCleared = typeAnyCleared && !typeAllCleared;
				dateTransactions.push(...transactions);

				const prev = prevUi.get(date);
				const detailExpanded = prev && prev.types.has(type) ? !!prev.types.get(type) : false;

				types.push({
					type,
					allCleared: typeAllCleared,
					partiallyCleared: typePartiallyCleared,
					total: typeTotal,
					detailExpanded,
					transactions,
				});

				dateTotal += typeTotal;
			});

			types.sort((a: any, b: any) => String(a.type).localeCompare(String(b.type)));

			const prevD = prevUi.get(date);
			const dateClearedCount = dateTransactions.filter((t) => this.isTransactionCleared(t)).length;
			const dateAllCleared = dateTransactions.length > 0 && dateClearedCount === dateTransactions.length;
			this.groupedTransactions.push({
				date,
				dateFmt: date,
				expanded: prevD ? prevD.dateExpanded : false,
				allCleared: dateAllCleared,
				partiallyCleared: dateClearedCount > 0 && !dateAllCleared,
				total: dateTotal,
				types,
			});
		});

		this.groupedTransactions.sort((a, b) => {
			return new Date(b.date).getTime() - new Date(a.date).getTime();
		});
	}

	toggleDateExpanded(dateGroup: any): void {
		dateGroup.expanded = !dateGroup.expanded;
	}

	toggleTypeDetail(typeGroup: any): void {
		typeGroup.detailExpanded = !typeGroup.detailExpanded;
	}

	showLedgerColumn(): boolean {
		return this.arapMode.value === 'both';
	}

	ledgerLabel(transaction: any): string {
		return Number(transaction.type) === 22 ? 'AP' : 'AR';
	}

	/** Resolve a paylocation code to its name; fall back to the raw code. */
	locName(code: any): string {
		if (code === null || code === undefined || code === '') {
			return '';
		}
		const match = (this.locations || []).find((loc: any) => loc.loccode === code);
		return match ? match.locationname : String(code);
	}

	toggleGroupedView(): void {
		this.groupedView = !this.groupedView;
		this.applyFilters();
	}

	isTransactionCleared(transaction: any): boolean {
		return !!transaction.isCleared || (transaction.amountCleared && parseFloat(transaction.amountCleared) > 0);
	}

	private getClearedAmount(transaction: any): number {
		const amount = parseFloat(transaction.ovamount);
		if (Number.isFinite(amount) && amount !== 0) {
			return Math.abs(amount);
		}
		const fallback = parseFloat(transaction.amount);
		return Number.isFinite(fallback) ? Math.abs(fallback) : 0;
	}

	private normalizeClearedLockedFlag(t: any): void {
		if (!t) {
			return;
		}
		const v = t.clearedLocked !== undefined && t.clearedLocked !== null ? t.clearedLocked : t.cleared_locked;
		t.clearedLocked = v === true || v === 1 || v === '1';
	}

	private bankTransId(trans: any): number {
		const v = trans?.banktransid;
		const n = parseInt(String(v), 10);
		return Number.isFinite(n) && n > 0 ? n : 0;
	}

	private applyLockApiResult(trans: any, r: any): void {
		if (!r) {
			return;
		}
		if (r.ok) {
			trans.clearedLocked = !!r.clearedLocked;
			if (r.amountCleared != null) {
				trans.amountCleared = r.amountCleared;
			}
		}
	}

	private applyUnlockApiResult(trans: any, r: any): void {
		if (r && r.ok) {
			trans.clearedLocked = false;
		}
	}

	onDayBulkChange(dateGroup: any, checked: boolean): void {
		const txs = dateGroup.types
			.reduce((all: any[], typeGroup: any) => all.concat(typeGroup.transactions || []), []);
		this.bulkSetCleared(txs, checked);
	}

	/**
	 * Apply one cleared/un-cleared state to a set of rec rows.
	 *
	 * Two rows are held back rather than posted:
	 *
	 * - `clearedLocked` — the pre-existing rule; the server refuses these anyway.
	 * - rows a bank line is matched to, when un-checking. A day header sweeps every
	 *   row of that day, so one tidy-up click used to post amountCleared=0 over rows
	 *   a feed match had just cleared and there was nothing to say it had happened.
	 *   Unmatch on the Bank Feed tab is the way to release one of these.
	 *
	 * Rows already in the target state are skipped too: a day of 59 rows was firing
	 * 59 requests to change 21, and every one of those wrote a `clearing` row.
	 */
	private bulkSetCleared(rows: any[], checked: boolean): void {
		const eligible = (rows || []).filter((t: any) => !t.clearedLocked);
		const held = checked ? [] : eligible.filter((t: any) => this.sfIsMatchedRow(t));
		const txs = eligible
			.filter((t: any) => !held.includes(t))
			.filter((t: any) => !!t.isCleared !== checked);
		if (held.length) {
			this.globalSearchService.showNotification(
				held.length + ' matched row' + (held.length === 1 ? '' : 's') + ' left cleared — unmatch on the Bank Feed tab to release ' + (held.length === 1 ? 'it' : 'them') + '.',
				'warning', 'bottom', 'center'
			);
		}
		if (!txs.length) {
			this.applyFilters();
			return;
		}
		txs.forEach((trans: any) => {
			trans.isCleared = checked;
			trans.amountCleared = checked ? this.getClearedAmount(trans) : 0;
		});
		const observables = txs.map((trans: any) => this.paymentsService.updateTransaction(trans));
		forkJoin(observables).subscribe({
			next: (responses: any[]) => {
				let refused = 0;
				txs.forEach((trans: any, i: number) => {
					const r = responses[i];
					if (r) {
						trans.isCleared = !!r.isCleared;
						trans.amountCleared = r.amountCleared != null ? r.amountCleared : trans.amountCleared;
						if (typeof r.clearedLocked !== 'undefined') {
							trans.clearedLocked = !!r.clearedLocked;
						}
						if (r.feedLinked) { refused++; }
					}
				});
				if (refused) {
					this.globalSearchService.showNotification(
						refused + ' row' + (refused === 1 ? '' : 's') + ' still matched to a bank line — left cleared.',
						'warning', 'bottom', 'center'
					);
				}
				this.applyFilters();
			},
			error: () => {
				this.applyFilters();
			},
		});
	}

	/**
	 * Is a bank feed line matched to this ERP row?
	 *
	 * Reads the match index the Bank Feed tab builds. When the feed has not been
	 * loaded the index is empty and this says false — the server-side guard in
	 * updateBankRec() is what makes the refusal authoritative in that case.
	 */
	private sfIsMatchedRow(t: any): boolean {
		const btid = this.bankTransId(t);
		return btid > 0 && !!this.sfMatchIdx[btid];
	}

	hasLockableClearedTransactions(dateGroup: any): boolean {
		return dateGroup.types
			.reduce((all: any[], typeGroup: any) => all.concat(typeGroup.transactions || []), [])
			.some((t: any) => !t.clearedLocked && this.isTransactionCleared(t));
	}

	lockDayClearedAmounts(dateGroup: any): void {
		const txs = dateGroup.types
			.reduce((all: any[], typeGroup: any) => all.concat(typeGroup.transactions || []), [])
			.filter((t: any) => {
				this.normalizeClearedLockedFlag(t);
				return !t.clearedLocked && this.isTransactionCleared(t) && this.bankTransId(t) > 0;
			});
		if (!txs.length) {
			return;
		}
		const observables = txs.map((trans: any) =>
			this.paymentsService.lockBankRec({ banktransid: this.bankTransId(trans) }).pipe(
				catchError(() => of({ ok: false }))
			)
		);
		forkJoin(observables).subscribe({
			next: (responses: any[]) => {
				txs.forEach((trans: any, i: number) => {
					this.applyLockApiResult(trans, responses[i]);
				});
				this.applyFilters();
				this._changeDetectorRef.markForCheck();
			},
			error: () => {
				this.applyFilters();
				this._changeDetectorRef.markForCheck();
			},
		});
	}

	unlockDayLockedAmounts(dateGroup: any): void {
		const txs = dateGroup.types
			.reduce((all: any[], typeGroup: any) => all.concat(typeGroup.transactions || []), [])
			.filter((t: any) => {
				this.normalizeClearedLockedFlag(t);
				return t.clearedLocked && this.bankTransId(t) > 0;
			});
		if (!txs.length) {
			return;
		}
		const observables = txs.map((trans: any) =>
			this.paymentsService.unlockBankRec({ banktransid: this.bankTransId(trans) }).pipe(
				catchError(() => of({ ok: false }))
			)
		);
		forkJoin(observables).subscribe({
			next: (responses: any[]) => {
				txs.forEach((trans: any, i: number) => {
					this.applyUnlockApiResult(trans, responses[i]);
				});
				this.applyFilters();
				this._changeDetectorRef.markForCheck();
			},
			error: () => {
				this.applyFilters();
				this._changeDetectorRef.markForCheck();
			},
		});
	}

	hasUnlockableLockedTransactions(dateGroup: any): boolean {
		return dateGroup.types
			.reduce((all: any[], typeGroup: any) => all.concat(typeGroup.transactions || []), [])
			.some((t: any) => {
				this.normalizeClearedLockedFlag(t);
				return t.clearedLocked && this.bankTransId(t) > 0;
			});
	}

	hasLockableClearedInSession(): boolean {
		const list = this.payments?.transactions;
		if (!Array.isArray(list)) {
			return false;
		}
		return list.some((t: any) => {
			this.normalizeClearedLockedFlag(t);
			return !t.clearedLocked && this.isTransactionCleared(t) && this.bankTransId(t) > 0;
		});
	}

	lockAllClearedInSession(): void {
		const list = this.payments?.transactions;
		if (!Array.isArray(list)) {
			return;
		}
		const txs = list.filter((t: any) => {
			this.normalizeClearedLockedFlag(t);
			return !t.clearedLocked && this.isTransactionCleared(t) && this.bankTransId(t) > 0;
		});
		if (!txs.length) {
			return;
		}
		this.lockingAllCleared = true;
		const observables = txs.map((t: any) =>
			this.paymentsService.lockBankRec({ banktransid: this.bankTransId(t) }).pipe(
				catchError(() => of({ ok: false }))
			)
		);
		forkJoin(observables)
			.pipe(finalize(() => {
				this.lockingAllCleared = false;
				this._changeDetectorRef.markForCheck();
			}))
			.subscribe({
				next: (responses: any[]) => {
					txs.forEach((trans: any, i: number) => {
						this.applyLockApiResult(trans, responses[i]);
					});
					this.applyFilters();
				},
				error: () => {
					this.applyFilters();
				},
			});
	}

	hasUnlockableLockedInSession(): boolean {
		const list = this.payments?.transactions;
		if (!Array.isArray(list)) {
			return false;
		}
		return list.some((t: any) => {
			this.normalizeClearedLockedFlag(t);
			return t.clearedLocked && this.bankTransId(t) > 0;
		});
	}

	unlockAllLockedInSession(): void {
		const list = this.payments?.transactions;
		if (!Array.isArray(list)) {
			return;
		}
		const txs = list.filter((t: any) => {
			this.normalizeClearedLockedFlag(t);
			return t.clearedLocked && this.bankTransId(t) > 0;
		});
		if (!txs.length) {
			return;
		}
		this.unlockingAllLocked = true;
		const observables = txs.map((t: any) =>
			this.paymentsService.unlockBankRec({ banktransid: this.bankTransId(t) }).pipe(
				catchError(() => of({ ok: false }))
			)
		);
		forkJoin(observables)
			.pipe(
				finalize(() => {
					this.unlockingAllLocked = false;
					this._changeDetectorRef.markForCheck();
				})
			)
			.subscribe({
				next: (responses: any[]) => {
					txs.forEach((trans: any, i: number) => {
						this.applyUnlockApiResult(trans, responses[i]);
					});
					this.applyFilters();
				},
				error: () => {
					this.applyFilters();
				},
			});
	}

	openBankGlJournalDialog(): void {
		const code = this.selectedBankAccount.value;
		if (!code) {
			this.globalSearchService.showNotification('Select a bank account first.', 'info', 'bottom', 'center');
			return;
		}
		const seed = this.dateto.value || this.today;
		this.dialog.open(SlimJournalEntryDialogComponent, {
			width: '720px',
			maxWidth: '96vw',
			maxHeight: '90vh',
			autoFocus: false,
			restoreFocus: true,
			data: {
				useBankOffsetJournal: true,
				preferredBankAccountCode: String(code),
				postingDate: seed,
			} as SlimJournalEntryDialogData,
		}).afterClosed().subscribe((r) => {
			if (r?.posted) {
				this.globalSearchService.showNotification('Journal posted.', 'success', 'bottom', 'center');
				this.refreshGlBookBalance();
				this.loadTransactions();
			}
		});
	}

	onTypeBulkChange(typeGroup: any, dateGroup: any, checked: boolean): void {
		// Unchecking any payment type clears the entire day (all types / all line items):
		// a day's deposit is reconciled as a unit, so releasing one tender releases the
		// day. bulkSetCleared() holds back rows a bank line is matched to, which is what
		// stops that sweep from erasing feed matches.
		const txs = !checked
			? dateGroup.types.reduce((all: any[], tg: any) => all.concat(tg.transactions || []), [])
			: typeGroup.transactions;
		this.bulkSetCleared(txs, checked);
	}

	ngOnInit(): void {
		this.globalSearchService.payment_methods.subscribe((methods) => {
			this.payment_methods = methods;
			this.paymenttypefilter.setValue(this.payment_methods);
		});

		this.globalSearchService.bankaccounts.subscribe((accounts: any) => {
			if (accounts && accounts.length) {
				this.bankAccounts = accounts;
				const defaultAccount = this.resolveDefaultBankAccount(
					accounts,
					this.config?.defaultBankAccount
				);
				this.selectedBankAccount.setValue(defaultAccount);
			}
		});

		this.statementVarianceSub = this.statementBalance.valueChanges.subscribe(() => {
			this.calculateVariance();
		});

		this.glBookRefreshSub = this.dateto.valueChanges
			.pipe(
				debounceTime(400),
				distinctUntilChanged((a, b) => {
					const ta = a ? new Date(a as any).getTime() : 0;
					const tb = b ? new Date(b as any).getTime() : 0;
					return ta === tb;
				})
			)
			.subscribe(() => this.refreshGlBookBalance());
	}

	get glBookChartCaption(): string {
		const code = this.selectedBankAccount.value;
		if (!code) {
			return '';
		}
		const acc = this.bankAccounts.find((a: any) => String(a?.accountcode) === String(code));
		const name = acc?.bankaccountname ? String(acc.bankaccountname) : '';
		return name ? `${name} · chart ${code}` : `Chart ${code}`;
	}

	private applyGlBookFromApi(payload: any): void {
		const gl = payload?.glBookBalance;
		const glNum = gl != null && gl !== '' ? parseFloat(String(gl)) : NaN;
		this.glBookBalance = Number.isFinite(glNum) ? glNum : null;
		const gp = payload?.glBookPeriod;
		const gpNum = gp != null && gp !== '' ? parseInt(String(gp), 10) : NaN;
		this.glBookPeriod = Number.isFinite(gpNum) ? gpNum : null;
	}

	refreshGlBookBalance(): void {
		const seq = ++this.glBookRequestSeq;
		const ac = this.selectedBankAccount.value;
		if (!ac) {
			this.glBookBalance = null;
			this.glBookPeriod = null;
			this.glBookLoadError = false;
			return;
		}
		this.glBookLoadError = false;
		this.paymentsService.getBankGlBook({ bankAccount: String(ac), asOf: this.dateto.value }).subscribe({
			next: (res: any) => {
				if (seq !== this.glBookRequestSeq) {
					return;
				}
				this.applyGlBookFromApi(res);
			},
			error: () => {
				if (seq !== this.glBookRequestSeq) {
					return;
				}
				this.glBookBalance = null;
				this.glBookPeriod = null;
				this.glBookLoadError = true;
			},
		});
	}

	resolveDefaultBankAccount(accounts: any[], preferred?: string): string {
		if (!accounts?.length) {
			return '';
		}
		const want = (preferred ?? '').toString().trim();
		if (want) {
			const hit = accounts.find((a: any) => String(a?.accountcode) === want);
			if (hit) {
				return String(hit.accountcode);
			}
		}
		return String(accounts[0].accountcode);
	}

	getFirstDayOfLastMonth(): Date {
		const now = new Date();
		const firstDayLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
		return firstDayLastMonth;
	}

	subscribeToGlobalUpdates(): void {
		// Subscribe to config updates
		this.globalSearchService.configsubscription.subscribe((config) => {
			this.config = config;
			if (this.config.env.package === 'beauty') {
			}
		});

		this.color = this.globalSearchService.getColor();
		this.globalSearchService.user.subscribe((userResults) => {
			if (this.user) {
				if (userResults.user.defaultlocation.loccode !== this.ref_location) {
					// Was: narrow to the user's new default location. On a bank rec that
					// hides every row keyed at another store — including their cleared
					// state — so a switch re-widens to all locations instead.
					this.selectAllLocations();
					this.ref_location = false;
				}
			}

			this.user = userResults;

			if (!this.ref_location) {
				this.ref_location = this.user.user.defaultlocation.loccode;
			}
		});

		// Check if the user is a POS user and fetch locations
		this.usersService.isPosUser().subscribe((isPOS) => {
			this.isPosUser = !!isPOS;

			this.globalsService.getLocations().subscribe((locations: any[]) => {
				if (locations) {
					this.locations = (this.isPosUser || this.user.user.issalesman) ?
						locations.filter((location) => location.loccode === this.user.user.defaultlocation.loccode) :
						locations;

					// A bank account is not per-store: reconciling it means seeing every
					// location's rows. POS users and salesmen are already restricted to
					// their own location by the filter above, so "all" stays correct
					// for them too.
					this.selectAllLocations();
				}
			});
		});

		// Fetch salespeople data
		this.reportsService.getSalesPeople().subscribe((salespeople: any) => {
			this.salespeople = salespeople;
		});
	}

	toggleClearView() {
		this.applyFilters();
		this.calculateVariance();
	}

	/**
	 * Ledger picker changed. Collapses the multi-select back onto the scalar the API
	 * takes; an empty selection means "show nothing", which applyFilters honours
	 * client-side rather than inventing a fourth arap_mode the server doesn't know.
	 */
	onArapModeChange(): void {
		const picked: string[] = Array.isArray(this.arapLedgers.value) ? this.arapLedgers.value.map((v: any) => String(v)) : [];
		const ar = picked.indexOf('ar') !== -1;
		const ap = picked.indexOf('ap') !== -1;
		const mode = (ar && ap) ? 'both' : (ap ? 'ap' : 'ar');
		if (this.arapMode.value !== mode) { this.arapMode.setValue(mode); }
		if (!picked.length) { this.applyFilters(); return; }
		this.loadTransactions();
	}

	/** No ledger selected — the list is empty by choice, not by failure. */
	get arapNoneSelected(): boolean {
		return Array.isArray(this.arapLedgers.value) && this.arapLedgers.value.length === 0;
	}

	onAmountInputChange(event: Event): void {
		const value = (event.target as HTMLInputElement).value;

	}


	loadTransactions(): void {
		if (!this.selectedBankAccount.value) {
			return;
		}

		const data = {
			from: this.datefrom.value,
			to: this.dateto.value,
			locations: this.defaultlocation.value,
			arap_mode: this.arapMode.value,
			showCleared: this.showCleared.value,
			payment_type: (this.paymenttypefilter && this.paymenttypefilter.value) ? this.paymenttypefilter.value.map((method: any) => method.paymentname) : [],
			bankAccount: this.selectedBankAccount.value,
		};

		this.running = true;
		this.glBookRequestSeq++;
		this.paymentsService.getBankRec(data).subscribe({
			next: (results: any) => {
				const copyofresults = results;
				if (!this.orignal_results) {
					this.orignal_results = {};
				}
				this.orignal_results.transactions = copyofresults.transactions;
				this.running = false;
				this.payments = results;

				this.glBookRequestSeq++;
				this.applyGlBookFromApi(results);
				this.glBookLoadError = false;

				this.applyFilters();

				const summary = Array.isArray(results.summary) ? results.summary : [];
				this.total_pay = summary.reduce(function(accumulator: number, items: any) {
					return accumulator + parseFloat(items.amount);
				}, 0);

				const parent = this;
				this.cctotal = summary.reduce(function(accumulator: number, items: any) {

					const ttype = parent.payment_methods.filter((t: any) => {
						return t.paymentname == items.type;
					})[0];
					let value = 0;

					if (ttype && ttype.cc_process == '1') {
						value = parseFloat(items.amount);
					}

					return accumulator + value;
				}, 0);

				const txns = Array.isArray(results.transactions) ? results.transactions : [];
				this.total_sub = txns.reduce(function(accumulator: number, items: any) {
					return accumulator + parseFloat(items.ovamount);
				}, 0);

				this.total_discount = txns.reduce(function(accumulator: number, items: any) {
					return accumulator + parseFloat(items.ovdiscount);
				}, 0);

				this.calculateVariance();
			},
			error: () => {
				this.running = false;
				this.glBookRequestSeq++;
				this.glBookBalance = null;
				this.glBookPeriod = null;
				this.glBookLoadError = true;
			},
		});
	}

	/**
	 * Has an operator actually keyed the statement balance?
	 *
	 * Blank is NOT zero. Treating it as zero makes "Statement − cleared" restate the
	 * whole cleared total as a shortage, which reads as a real out-of-balance when it
	 * only means nobody has typed the bank's figure in yet.
	 */
	hasStatementBalance(): boolean {
		const v = this.statementBalance.value;
		return v !== null && v !== undefined && String(v).trim() !== '';
	}

	calculateVariance(): void {
		this.clearedTotal = this.filteredTransactions
			.filter((t: any) => t.isCleared || (t.amountCleared && t.amountCleared > 0))
			.reduce((acc: number, t: any) => {
				const amt = parseFloat(t.amount) || 0;
				return acc + amt;
			}, 0);

		const stmtBal = parseFloat(this.statementBalance.value) || 0;
		this.variance = stmtBal - this.clearedTotal;
	}

	toggleEdit(transaction: any): void {
		if (transaction.clearedLocked) {
			return;
		}
		// Toggle selection state
		transaction.isSelected = !transaction.isSelected;

		// Initialize default values if needed
		if (transaction.isSelected) {
			this.temporaryAmount.setValue(transaction.amountCleared);
			if (!transaction.amountCleared) {
				transaction.amountCleared = Math.abs(transaction.alloc || 0);
			}
			this.temporaryAmount.setValue(transaction.amountCleared);
			transaction.isCleared = false; // Default to not cleared
		}
	}

	togglePopover(transaction: any): void {

		this.temporaryAmount.setValue(transaction.amountCleared);

		transaction.isSelected = !transaction.isSelected;

		// Initialize default values when selected
		// if (transaction.isSelected) {
		//   transaction.amountCleared = transaction.alloc || 0; // Default to allocated amount
		//   transaction.isCleared = false; // Default to not cleared
		// }
	}

	saveTransaction(transaction: any): void {
		// Optionally close the popover after saving
		transaction.isSelected = false;
		this.togglePopover(transaction)
	}
	onClearChange(transaction: any): void {
		// Update partially cleared state
		if (transaction.isCleared) {
			transaction.isPartiallyCleared = false;
		}
	}

	savePartial(transaction: any): void {
		if (transaction.clearedLocked) {
			return;
		}
		transaction.amountCleared = this.temporaryAmount.value;

		this.paymentsService.updateTransaction(transaction).subscribe({
			next: (response) => {
				transaction.isCleared = response.isCleared;
				transaction.amountCleared = response.amountCleared;
				transaction.clearedLocked = !!response.clearedLocked;
				transaction.isSelected = false;
				this.applyFilters();
			},
			error: (error) => console.error('Error updating transaction:', error),
		});

	}

	unlockClearedLock(transaction: any): void {
		const id = this.bankTransId(transaction);
		if (id < 1) {
			return;
		}
		this.paymentsService.unlockBankRec({ banktransid: id }).subscribe({
			next: (res: any) => {
				this.applyUnlockApiResult(transaction, res);
				this.applyFilters();
				this._changeDetectorRef.markForCheck();
			},
			error: (error) => console.error('Error unlocking bank rec row:', error),
		});
	}

	lockClearedAmount(transaction: any): void {
		this.normalizeClearedLockedFlag(transaction);
		if (transaction.clearedLocked || !this.isTransactionCleared(transaction) || this.bankTransId(transaction) < 1) {
			return;
		}
		this.paymentsService.lockBankRec({ banktransid: this.bankTransId(transaction) }).subscribe({
			next: (res: any) => {
				this.applyLockApiResult(transaction, res);
				this.applyFilters();
				this._changeDetectorRef.markForCheck();
			},
			error: (error) => console.error('Error locking bank rec row:', error),
		});
	}

	onRowClearChange(transaction: any, ev: Event): void {
		this.normalizeClearedLockedFlag(transaction);
		if (transaction.clearedLocked) {
			const input = ev.target as HTMLInputElement;
			if (input) {
				input.checked = this.isTransactionCleared(transaction);
			}
			return;
		}
		const input = ev.target as HTMLInputElement;
		const checked = !!input?.checked;
		transaction.isCleared = checked;
		transaction.amountCleared = checked ? this.getClearedAmount(transaction) : 0;

		this.paymentsService.updateTransaction(transaction).subscribe({
			next: (response: any) => {
				if (response) {
					transaction.isCleared = !!response.isCleared;
					transaction.amountCleared = response.amountCleared != null ? response.amountCleared : transaction.amountCleared;
					if (typeof response.clearedLocked !== 'undefined') {
						transaction.clearedLocked = !!response.clearedLocked;
					}
				}
				// Do NOT re-run applyFilters here — that would filter out the just-cleared
				// row when showCleared=false, making it look like the check didn't hold.
				// Rebuild group states and recalculate variance from the current filtered set.
				this.buildGroupedView();
				this.calculateVariance();
				this._changeDetectorRef.markForCheck();
			},
			error: (error) => console.error('Error updating transaction:', error),
		});
	}


	/** Every location the user is allowed to see — the rec's default selection. */
	private selectAllLocations(): void {
		this.defaultlocation.setValue((this.locations || []).map((l: any) => l.loccode));
	}

	populateLocations(): void {
		this.locations = this.transactions.map(transaction => ({
			loccode: transaction.locationCode,
			locationname: transaction.locationName,
		}));

		// Prepopulate default locations
		const defaultLocCodes = this.locations.map(loc => loc.loccode);
		this.defaultlocation.setValue(defaultLocCodes);
	}

	trackByTransaction(index: number, transaction: any): number {
		return transaction.banktransid != null ? transaction.banktransid : transaction.transno;
	}

	trackByDateGroup(_index: number, dateGroup: any): string {
		return dateGroup.date || String(_index);
	}


	// --- SimpleFIN integration ---
	setIntegrationsTab(): void {
		this.activeTab = 'integrations';
		if (!this.sf.loaded) {
			this.loadSimplefinStatus();
			return;
		}
		// The feed/ERP panes read bank_feed_transactions and banktrans directly —
		// neither depends on a live SimpleFIN bridge, only file-drop imports do.
		// Gating this load on sf.connected hid dropped-statement data entirely.
		if (this.sf.connected) { this.sfAdoptMappedBankAccount(); }
		this.loadSimplefinFeed();
		this.sfLoadErpRows(true);
	}

	/**
	 * Connections tab: SimpleFIN connect/account-mapping only. Only needs sf.loaded
	 * (for sf.accounts, sf.connected) — no feed/ERP rows, this tab doesn't match
	 * anything.
	 */
	setConnectionsTab(): void {
		this.activeTab = 'connections';
		if (!this.sf.loaded) { this.loadSimplefinStatus(); }
	}

	/**
	 * Statement Files tab: drop a downloaded statement + its history. Needs
	 * sf.bankAccounts for the account picker — that list comes from
	 * simplefinStatus, which reads `bankaccounts` LIVE, unlike the
	 * globalSearchService copy which is served from a permanent file cache.
	 * Independent of sf.connected — a tenant with no bridge at all still uses this.
	 */
	setStatementFilesTab(): void {
		this.activeTab = 'files';
		if (!this.sf.loaded) { this.loadSimplefinStatus(); }
	}

	/* ---------- Bank feed exports ---------- */

	/**
	 * Which status chip the export is describing. The four chips all narrow the same
	 * sfBankRows(), so one export path serves all of them — the label is what tells the
	 * reader (and the filename) which slice they got.
	 */
	sfChipLabel(): string {
		switch (this.sfStatusFilter) {
		case 'matched': return 'Matched only';
		case 'ignored': return 'Ignored';
		case 'all': return 'All rows';
		default: return 'Work queue (unmatched)';
		}
	}

	/** Per-row state, flattened for a spreadsheet cell. */
	sfRowStateLabel(s: any): string {
		if (!s) { return ''; }
		if (s.ignored) { return 'Ignored'; }
		if (s.feedPosted) { return 'Posted from feed' + (s.feedPostKind ? ' (' + s.feedPostKind + ')' : ''); }
		if (s.matched) {
			const n = Array.isArray(s.matchList) ? s.matchList.length : 1;
			return 'Matched' + (n > 1 ? ' (' + n + ' ERP rows)' : '') + (s.matchAi ? ' — AI' : '');
		}
		return 'Unmatched';
	}

	sfExportTotal(): number {
		return this.round2(this.sfBankRows().reduce((sum: number, s: any) => sum + (Number(s.amount) || 0), 0));
	}

	/** m/d/yyyy for the export header — sfFormatYmd is for API params, not humans. */
	sfFormatYmdDisplay(d: any): string {
		const ymd = this.sfFormatYmd(d);
		if (!ymd) { return ''; }
		const parts = ymd.split('-');
		return parts[1] + '/' + parts[2] + '/' + parts[0];
	}

	/**
	 * Export the visible feed rows. Follows the house pattern: base64 the print table's
	 * innerHTML and let print/xls or print/pdf render it server side, so the export
	 * always matches what is on screen and needs no second query.
	 */
	sfExportFeed(kind: 'xlsx' | 'pdf'): void {
		if (!this.sfBankRows().length) { this.sf.message = 'No rows in this view to export.'; return; }
		// Mount the table, let Angular render it, then read it back.
		this.sfPrintReady = true;
		this._changeDetectorRef.detectChanges();
		const source = this.sfFeedPrint && this.sfFeedPrint.nativeElement;
		if (!source) {
			this.sfPrintReady = false;
			this.sf.message = 'Could not build the export.';
			return;
		}

		const account = String(this.selectedBankAccount.value || 'bank');
		const slug = this.sfChipLabel().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
		const base = 'bank-feed_' + account + '_' + slug + '_' + this.sfFormatYmd(this.datefrom.value) + '_' + this.sfFormatYmd(this.dateto.value);
		const content = this.globalSearchService.base64encode(source.innerHTML);
		// HTML captured — drop the table straight back out of the DOM.
		this.sfPrintReady = false;

		this.sfExporting = kind;
		if (kind === 'xlsx') {
			const data = { content, filename: base + '.xlsx', landscape: true };
			this.printService.xls(data).subscribe(
				(result: any) => {
					this.sfExporting = '';
					if (result && result.content) {
						// downloadXls, not downloadPdf — the spreadsheet MIME type matters or
						// Excel refuses the file.
						this.globalSearchService.downloadXls(result.content, data.filename);
					} else {
						this.sf.message = 'Excel export failed.';
					}
				},
				() => { this.sfExporting = ''; this.sf.message = 'Excel export failed.'; }
			);
			return;
		}
		const data = { content, filename: base + '.pdf', landscape: true };
		this.printService.pdf(data).subscribe(
			(result: any) => {
				this.sfExporting = '';
				if (result && result.content) {
					this.globalSearchService.downloadPdf(result.content, data.filename);
				} else {
					this.sf.message = 'PDF export failed.';
				}
			},
			() => { this.sfExporting = ''; this.sf.message = 'PDF export failed.'; }
		);
	}

	/* ---------- Batch match: N ERP rows settle ONE bank line ---------- */

	/**
	 * Batch match tab. Needs sf.bankAccounts for the account picker, then the
	 * per-account rules — the proposals are useless until the rules are right, so
	 * settings load first and the (expensive) proposal pass waits for a click.
	 */
	setGroupsTab(): void {
		this.activeTab = 'groups';
		if (!this.sf.loaded) { this.loadSimplefinStatus(); }
		if (!this.grp.bankaccount) {
			this.grp.bankaccount = String(this.selectedBankAccount.value || '');
		}
		if (this.grp.bankaccount && !this.grp.settings) { this.grpLoadSettings(); }
	}

	/** Account changed: rules are per-account, so drop the proposals with them. */
	grpAccountChanged(): void {
		this.grp.settings = null;
		this.grp.proposals = [];
		this.grp.counts = { lines: 0, withGroups: 0 };
		this.grp.expanded = {};
		this.grp.message = '';
		if (this.grp.bankaccount) { this.grpLoadSettings(); }
	}

	grpLoadSettings(): void {
		if (!this.grp.bankaccount) { return; }
		this.paymentsService.simplefinGroupSettings({ bankaccount: this.grp.bankaccount }).subscribe(
			(res: any) => {
				this.grp.loaded = true;
				if (res && res.success) {
					this.grp.settings = this.grpNormalizeSettings(res.settings);
					this.grp.tenderTypes = res.tenderTypes || [];
				} else {
					this.grp.message = (res && res.error) ? res.error : 'Could not load grouping rules.';
				}
			},
			() => { this.grp.loaded = true; this.grp.message = 'Could not load grouping rules.'; }
		);
	}

	/** Server omits keys it has no value for; the template binds them all. */
	private grpNormalizeSettings(s: any): any {
		const src = s || {};
		return {
			self_account: String(src.self_account || this.grp.bankaccount),
			offset_accounts: Array.isArray(src.offset_accounts) ? src.offset_accounts.map((a: any) => String(a)) : [],
			lag_days_back: Number(src.lag_days_back ?? 5),
			lag_days_fwd: Number(src.lag_days_fwd ?? 1),
			variance_abs: Number(src.variance_abs ?? 0),
			variance_pct: Number(src.variance_pct ?? 0),
			tender_groups: Array.isArray(src.tender_groups)
				? src.tender_groups.map((g: any) => ({ label: String(g?.label || ''), types: Array.isArray(g?.types) ? g.types.map((t: any) => String(t)) : [] }))
				: [],
			// {type: dollars} — per-tender over/short allowance (cash drawers).
			type_variances: (src.type_variances && typeof src.type_variances === 'object') ? { ...src.type_variances } : {},
		};
	}

	grpTypeVarEntries(): { type: string; amount: number }[] {
		const tv = (this.grp.settings && this.grp.settings.type_variances) || {};
		return Object.keys(tv).map((k: string) => ({ type: k, amount: Number(tv[k]) }));
	}

	grpAddTypeVariance(): void {
		const type = (this.grp.newVarType || '').trim();
		const amt = Number(this.grp.newVarAmount);
		if (!type || !(amt > 0) || !this.grp.settings) { return; }
		this.grp.settings.type_variances[type] = Math.round(amt * 100) / 100;
		this.grp.newVarType = '';
		this.grp.newVarAmount = null;
	}

	grpRemoveTypeVariance(type: string): void {
		if (this.grp.settings && this.grp.settings.type_variances) {
			delete this.grp.settings.type_variances[type];
		}
	}

	grpSaveSettings(): void {
		if (!this.grp.bankaccount || !this.grp.settings) { return; }
		this.grp.savingSettings = true;
		this.grp.message = '';
		const s = this.grp.settings;
		this.paymentsService.simplefinGroupSettings({
			bankaccount: this.grp.bankaccount,
			save: true,
			offset_accounts: s.offset_accounts,
			lag_days_back: Number(s.lag_days_back) || 0,
			lag_days_fwd: Number(s.lag_days_fwd) || 0,
			variance_abs: Number(s.variance_abs) || 0,
			variance_pct: Number(s.variance_pct) || 0,
			tender_groups: s.tender_groups,
			type_variances: s.type_variances,
		}).subscribe(
			(res: any) => {
				this.grp.savingSettings = false;
				if (res && res.success) {
					// The server drops one-type and overlapping groups — show what it kept.
					this.grp.settings = this.grpNormalizeSettings(res.settings);
					this.grp.tenderTypes = res.tenderTypes || this.grp.tenderTypes;
					this.grp.message = 'Rules saved.';
					this.grpPropose();
				} else {
					this.grp.message = (res && res.error) ? res.error : 'Could not save rules.';
				}
			},
			() => { this.grp.savingSettings = false; this.grp.message = 'Could not save rules.'; }
		);
	}

	/** A tender group needs 2+ types — one type is what the plain per-type shape does. */
	grpAddTenderGroup(): void {
		const label = (this.grp.newTenderLabel || '').trim();
		const types = (this.grp.newTenderTypes || []).slice();
		if (!label || types.length < 2 || !this.grp.settings) { return; }
		this.grp.settings.tender_groups.push({ label, types });
		this.grp.newTenderLabel = '';
		this.grp.newTenderTypes = [];
	}

	grpRemoveTenderGroup(index: number): void {
		if (!this.grp.settings) { return; }
		this.grp.settings.tender_groups.splice(index, 1);
	}

	/** Types already claimed by a saved group can't join another one. */
	grpTenderTypeTaken(type: string): boolean {
		const groups = (this.grp.settings && this.grp.settings.tender_groups) || [];
		return groups.some((g: any) => (g.types || []).some((t: string) => String(t).toLowerCase() === String(type).toLowerCase()));
	}

	grpPropose(): void {
		if (!this.grp.bankaccount) { this.grp.message = 'Pick a bank account first.'; return; }
		this.grp.loading = true;
		this.grp.message = '';
		this.grp.expanded = {};
		this.paymentsService.simplefinProposeGroups({
			bankaccount: this.grp.bankaccount,
			start: this.sfFormatYmd(this.datefrom.value),
			end: this.sfFormatYmd(this.dateto.value),
			limit: 100,
		}).subscribe(
			(res: any) => {
				this.grp.loading = false;
				if (res && res.success) {
					this.grp.proposals = res.proposals || [];
					this.grp.poolSize = Number(res.poolSize || 0);
					this.grp.poolWindow = res.poolWindow || [];
					this.grp.counts = res.counts || { lines: 0, withGroups: 0 };
					if (res.settings) { this.grp.settings = this.grpNormalizeSettings(res.settings); }
					if (!this.grp.proposals.length) {
						this.grp.message = 'No unmatched bank lines in this range.';
					}
				} else {
					this.grp.message = (res && res.error) ? res.error : 'Could not build proposals.';
				}
			},
			() => { this.grp.loading = false; this.grp.message = 'Could not build proposals.'; }
		);
	}

	/** Lines worth showing: hide the ones the server found nothing for. */
	grpVisibleProposals(): any[] {
		const all = this.grp.proposals || [];
		const list = this.grp.onlyTies ? all.filter((p: any) => (p.groups || []).length) : all;
		// Oldest first. The server orders by amount so the biggest lines surface, but a
		// reconciliation is worked day by day — a date order is the only one where you
		// can see a day close.
		return list.slice().sort((a: any, b: any) =>
			String(a.posted || '').localeCompare(String(b.posted || '')) ||
			(Number(b.amount) || 0) - (Number(a.amount) || 0));
	}

	/** Day header shown once per posted date in the proposal list. */
	grpIsNewDay(list: any[], i: number): boolean {
		return i === 0 || String(list[i].posted) !== String(list[i - 1].posted);
	}

	grpDayLines(list: any[], posted: string): number {
		return list.filter((p: any) => String(p.posted) === String(posted)).length;
	}

	/** The exact-tie candidate on a line, if it has one. */
	grpExactOf(p: any): any {
		return (p.groups || []).find((g: any) => g.tier === 1) || null;
	}

	/**
	 * The candidate the line header summarises: best tier, then smallest variance, then
	 * fewest rows — the same order the list itself is sorted in, so the header always
	 * describes the group shown first underneath it rather than an arbitrary one.
	 */
	grpBest(p: any): any {
		const gs = (p && p.groups) || [];
		if (!gs.length) { return null; }
		return gs.reduce((best: any, g: any) => {
			if (!best) { return g; }
			if (g.tier !== best.tier) { return g.tier < best.tier ? g : best; }
			const dv = Math.abs(Number(g.variance) || 0) - Math.abs(Number(best.variance) || 0);
			if (Math.abs(dv) > 0.004) { return dv < 0 ? g : best; }
			return (g.count || 0) < (best.count || 0) ? g : best;
		}, null);
	}

	grpExactCount(): number {
		return this.grpVisibleProposals().filter((p: any) => this.grpExactOf(p)).length;
	}

	grpExactValue(): number {
		return this.round2(this.grpVisibleProposals()
			.filter((p: any) => this.grpExactOf(p))
			.reduce((s: number, p: any) => s + (Number(p.amount) || 0), 0));
	}

	/**
	 * Post every exact tie in one pass.
	 *
	 * Sequential, not parallel: each accept consumes ERP rows that a later line might
	 * also have been offered, so firing them together would let two bank lines claim
	 * the same receipt. One at a time, and the double-claim guard stays meaningful.
	 */
	grpMatchAllExact(): void {
		if (this.grpBulk.running) { return; }
		const queue = this.grpVisibleProposals()
			.map((p: any) => ({ p, g: this.grpExactOf(p) }))
			.filter((x: any) => x.g);
		if (!queue.length) { return; }
		this.grpBulk = { running: true, done: 0, total: queue.length, failed: 0 };
		this.grpRunBulk(queue, 0);
	}

	private grpRunBulk(queue: any[], i: number): void {
		if (i >= queue.length) {
			this.grpBulk.running = false;
			this.grp.message = 'Matched ' + this.grpBulk.done + ' of ' + this.grpBulk.total + ' exact tie'
				+ (this.grpBulk.total === 1 ? '' : 's')
				+ (this.grpBulk.failed ? ', ' + this.grpBulk.failed + ' could not be posted' : '') + '.';
			// One quiet re-read at the end so the rec pane agrees; the list itself was
			// already updated in place as each group posted.
			if (this.payments && this.payments.transactions) { this.sfLoadErpRows(true); }
			return;
		}
		const { p, g } = queue[i];
		const key = this.grpKey(p, (p.groups || []).indexOf(g));
		this.grpPostGroup(p, g, key,
			() => { this.grpBulk.done++; this.grpRunBulk(queue, i + 1); },
			() => { this.grpBulk.failed++; this.grpRunBulk(queue, i + 1); });
	}

	grpKey(p: any, gi: number): string {
		return String(p?.sf_account || '') + '|' + String(p?.sf_id || '') + '|' + gi;
	}

	grpToggleRows(p: any, gi: number): void {
		const k = this.grpKey(p, gi);
		this.grp.expanded[k] = !this.grp.expanded[k];
	}

	grpTierLabel(tier: number): string {
		if (tier === 1) { return 'Exact'; }
		if (tier === 2) { return 'Within tolerance'; }
		return 'Exact after dropping stragglers';
	}

	/** Plain-English shape, so a reviewer knows what claim they're accepting. */
	grpShapeLabel(g: any): string {
		let shape = String(g?.shape || '');
		const tender = String(g?.tender || '');
		// "+codep" = this ERP day was banked as several slips. Say so up front, because
		// accepting it also matches the sibling lines listed under the candidate.
		let codep = '';
		if (shape.endsWith('+codep')) {
			shape = shape.slice(0, -'+codep'.length);
			const n = (((g && g.siblings) || []).length) + 1;
			codep = ', banked as ' + n + ' deposits';
		}
		if (codep) { return this.grpShapeLabelBase(shape, tender, g) + codep; }
		return this.grpShapeLabelBase(shape, tender, g);
	}

	private grpShapeLabelBase(shape: string, tender: string, g: any): string {
		if (shape === 'date+tender') { return 'One day of ' + tender; }
		if (shape === 'window+tender') { return tender + ' across the window'; }
		// "+net" shapes include the day's refunds/chargebacks, which is how a card
		// processor actually settles — say so, because the row list will contain
		// negatives and a reviewer should know that is deliberate.
		if (shape === 'date+tender+net') { return 'One day of ' + tender + ', refunds netted'; }
		if (shape === 'date+type+net') { return 'One day of ' + (g.types ? Object.keys(g.types).join(', ') : 'one tender') + ', refunds netted'; }
		if (shape === 'date+type') { return 'One day of ' + (g.types ? Object.keys(g.types).join(', ') : 'one tender'); }
		if (shape === 'date+type+loc') { return 'One day, one tender, one location'; }
		if (shape === 'date+loc') { return 'One day, one location'; }
		if (shape === 'date') { return 'One whole day'; }
		if (shape === 'window+type') { return 'One tender across the window'; }
		return 'The whole window';
	}

	grpTypeSummary(g: any): string {
		const types = (g && g.types) || {};
		return Object.keys(types).map((k: string) => k + ' ×' + types[k]).join(' · ');
	}

	/**
	 * Accept a group: one match link per ERP row, all pointing at this bank line.
	 * allow_shared stays OFF — each banktransid is claimed by exactly one feed row
	 * here, so the double-claim guard is still doing useful work.
	 */
	grpAcceptGroup(p: any, g: any, gi: number): void {
		const rows = (g && g.rows) || [];
		if (!rows.length) { return; }
		const key = this.grpKey(p, gi);
		if (this.grp.matching[key]) { return; }
		// No confirm() dialog. A match is not destructive and Unmatch reverses it in one
		// click, so a modal per group just made a 40-line day unworkable. What the group
		// contains is on screen before the button is pressed, which is the real safeguard.
		this.grpPostGroup(p, g, key);
	}

	/**
	 * Save a group's links then clear its rows. Shared by the single Match button and
	 * the bulk exact-tie pass, so both take exactly the same server path.
	 */
	private grpPostGroup(p: any, g: any, key: string, onDone?: () => void, onFail?: () => void): void {
		const rows = (g && g.rows) || [];
		this.grp.matching[key] = true;
		// A non-zero variance is a real over/short (cash drawers, mostly). It goes in the
		// match reason so the discrepancy stays on the record — visible on the row detail
		// and queryable for the over/short journal — instead of being absorbed silently.
		const overShort = Number(g.variance) ? ', over/short ' + this.currencyish(g.variance) : '';
		const reason = this.grpTierLabel(g.tier) + ' — ' + this.grpShapeLabel(g) + ', ' + rows.length + ' rows' + overShort;
		// A co-deposit group is one ERP day banked as several slips, so the SAME ERP rows
		// link to every slip. That is the one case where sharing a banktransid is correct
		// rather than a double-claim, which is exactly what allow_shared exists for.
		const lines = [{ sf_account: p.sf_account, sf_id: p.sf_id }]
			.concat(((g.siblings || []) as any[]).map((s: any) => ({ sf_account: s.sf_account, sf_id: s.sf_id })));
		const shared = lines.length > 1;
		const matches: any[] = [];
		for (const ln of lines) {
			for (const r of rows) {
				matches.push({
					sf_account: ln.sf_account,
					sf_id: ln.sf_id,
					banktransid: Number(r.banktransid),
					transno: Number(r.transno),
					method: 'auto',
					reason: reason,
				});
			}
		}
		this.paymentsService.simplefinSaveMatches(shared ? { matches, allow_shared: true } : { matches }).subscribe(
			(res: any) => {
				if (res && res.success) {
					// Recording the pairing is only half of it — the rec reads
					// banktrans.amountcleared, so the rows have to be cleared too or the
					// match is invisible on the Reconciliation tab.
					this.grpClearGroup(p, g, key, Number(res.saved || matches.length), onDone, onFail);
				} else {
					this.grp.matching[key] = false;
					this.grp.message = (res && res.error) ? res.error : 'Could not save the match.';
					if (onFail) { onFail(); }
				}
			},
			() => {
				this.grp.matching[key] = false;
				this.grp.message = 'Could not save the match.';
				if (onFail) { onFail(); }
			}
		);
	}

	/**
	 * Tick the group's ERP rows cleared on the rec, in ONE call.
	 *
	 * Deliberately the batch endpoint rather than the rec's per-row updateTransaction:
	 * a group is routinely 40+ rows, and the batch call is also the only one that
	 * reports which rows it refused (cleared_locked) instead of failing quietly.
	 */
	private grpClearGroup(p: any, g: any, key: string, saved: number, onDone?: () => void, onFail?: () => void): void {
		// During a bulk pass the caller re-proposes once at the end; re-running the
		// (expensive) proposal query after every group would make 34 groups unusable.
		const bulk = !!onDone;
		const rows = ((g && g.rows) || []).filter((r: any) => !r.cleared);
		if (!rows.length) {
			this.grp.matching[key] = false;
			this.grp.message = 'Matched ' + saved + ' ERP row' + (saved === 1 ? '' : 's') + ' (already cleared on the rec).';
			if (bulk) { onDone(); return; }
			this.grpPropose();
			return;
		}
		const payload = rows.map((r: any) => ({ banktransid: Number(r.banktransid), amountCleared: Number(r.amount) }));
		this.paymentsService.batchUpdateBankRec(payload).subscribe(
			(res: any) => {
				this.grp.matching[key] = false;
				const counts = (res && res.counts) || {};
				const updated = Number(counts.updated || 0);
				const locked = Number(counts.locked || 0);
				const missing = Number(counts.missing || 0);
				let msg = 'Matched ' + saved + ' ERP row' + (saved === 1 ? '' : 's') + ', cleared ' + updated + ' on the rec.';
				if (locked) { msg += ' ' + locked + ' skipped — locked.'; }
				if (missing) { msg += ' ' + missing + ' no longer exist.'; }
				const linked = Number(counts.linked || 0);
				if (linked) { msg += ' ' + linked + ' already matched to another bank line.'; }
				this.grp.message = msg;
				// Update in place instead of re-running the proposal query. A full
				// re-propose blanks the list and throws away the scroll position, which
				// loses your place halfway down a month.
				this.grpConsume(p, g);
				if (bulk) { onDone(); return; }
				// The rec pane holds its own copy of these rows; re-read quietly.
				if (this.payments && this.payments.transactions) { this.sfLoadErpRows(true); }
			},
			() => {
				this.grp.matching[key] = false;
				this.grp.message = 'Match saved, but clearing the rec failed — re-run Propose groups and retry.';
				if (bulk) { onFail(); return; }
			}
		);
	}

	/**
	 * Retire an accepted line and prune what it consumed, without a round trip.
	 *
	 * The accepted line goes; every other line loses any candidate group that shared an
	 * ERP row with it, because those rows are now claimed. A line left with no candidate
	 * stays on the list — it still needs attention, it just has nothing to offer.
	 */
	private grpConsume(p: any, g: any): void {
		const used = new Set<number>(((g && g.rows) || []).map((r: any) => Number(r.banktransid)));
		const all = this.grp.proposals || [];
		const i = all.indexOf(p);
		if (i >= 0) { all.splice(i, 1); }
		// A co-deposit settled its sibling slips in the same post, so they retire too.
		for (const s of ((g && g.siblings) || [])) {
			const si = all.findIndex((x: any) => String(x.sf_id) === String(s.sf_id)
				&& String(x.sf_account) === String(s.sf_account));
			if (si >= 0) { all.splice(si, 1); }
		}
		for (const other of all) {
			if (!other.groups || !other.groups.length) { continue; }
			other.groups = other.groups.filter((cand: any) =>
				!(cand.banktransids || []).some((id: any) => used.has(Number(id))));
		}
		// Keep the chip counters honest now the list has changed.
		this.grp.counts = {
			lines: all.length,
			withGroups: all.filter((x: any) => (x.groups || []).length).length,
		};
		// Expanded/matching flags are keyed by index, which has just shifted.
		this.grp.expanded = {};
		this.grp.matching = {};
	}

	/** confirm() takes a string, so the currency pipe isn't available. */
	private currencyish(n: any): string {
		const v = Number(n);
		if (!Number.isFinite(v)) { return String(n); }
		return '$' + v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	}

	private loadSimplefinStatus(): void {
		this.paymentsService.simplefinStatus().subscribe(
			(res: any) => {
				this.sf.loaded = true;
				if (res && res.success) {
					this.sf.connected = !!res.connected;
					this.sf.accountMap = this.sfNormalizeMap(res.accountMap);
					this.sf.bankAccounts = res.bankAccounts || [];
					this.sf.lastImport = res.lastImport || null;
					if (this.sf.connected) {
						this.sfAdoptMappedBankAccount();
						this.loadSimplefinAccounts();
						this.loadSimplefinFeed();
						this.sfLoadErpRows(true);
					}
				}
			},
			() => { this.sf.loaded = true; }
		);
	}

	simplefinConnect(): void {
		const token = (this.sf.token || '').trim();
		if (!token) { this.sf.message = 'Paste a setup token first.'; return; }
		this.sf.claiming = true;
		this.sf.message = '';
		this.paymentsService.simplefinClaim(token).subscribe(
			(res: any) => {
				this.sf.claiming = false;
				if (res && res.success) {
					this.sf.connected = true;
					this.sf.token = '';
					this.sf.message = 'Connected to SimpleFIN.';
					this.loadSimplefinAccounts();
				} else {
					this.sf.message = (res && res.error) ? res.error : 'Connect failed.';
				}
			},
			() => { this.sf.claiming = false; this.sf.message = 'Connect failed.'; }
		);
	}

	loadSimplefinAccounts(): void {
		this.sf.loadingAccounts = true;
		this.paymentsService.simplefinAccounts().subscribe(
			(res: any) => {
				this.sf.loadingAccounts = false;
				if (res && res.success) {
					this.sf.accounts = res.accounts || [];
					if (res.accountMap) { this.sf.accountMap = this.sfNormalizeMap(res.accountMap); }
					this.sfAdoptMappedBankAccount();
					this.sf.errors = res.errors || [];
					this.sf.manageUrl = res.manageUrl || '';
				} else {
					this.sf.message = (res && res.error) ? res.error : 'Could not load accounts.';
				}
			},
			() => { this.sf.loadingAccounts = false; }
		);
	}

	/** Persist the SimpleFIN-account -> ERP-bank-account mapping on change. */
	simplefinMapChanged(): void {
		this.sfSavingMap = true;
		this.sf.message = 'Saving account mapping…';
		this.paymentsService.simplefinSetMap(this.sf.accountMap).subscribe(
			(res: any) => {
				this.sfSavingMap = false;
				if (res && res.success) {
					if (res.accountMap && !Array.isArray(res.accountMap)) {
						this.sf.accountMap = this.sfNormalizeMap(res.accountMap);
					}
					this.sfAdoptMappedBankAccount();
					this.sf.message = 'Account mapping saved.';
					// Saving the map re-points already-imported rows server-side —
					// reload so the ERP bank column and deposit totals reflect it.
					this.loadSimplefinFeed();
					this.sfLoadErpRows(true);
				} else {
					this.sf.message = (res && res.error) ? res.error : 'Saving the account mapping failed.';
				}
			},
			() => { this.sfSavingMap = false; this.sf.message = 'Saving the account mapping failed.'; }
		);
	}

	private sfAdoptMappedBankAccount(): void {
		const mapped = Object.keys(this.sf.accountMap || {})
			.map((key: string) => String(this.sf.accountMap[key] || '').trim())
			.find((code: string) => !!code);
		if (mapped && String(this.selectedBankAccount.value || '') !== mapped) {
			this.selectedBankAccount.setValue(mapped);
		}
	}

	/**
	 * The map must be a keyed object. PHP's json_encode turns an empty map into
	 * [] (an array); adopting that as the model silently loses every later
	 * selection, because string keys on a JS array are dropped by JSON.stringify.
	 */
	private sfNormalizeMap(m: any): { [sfId: string]: string } {
		return (m && typeof m === 'object' && !Array.isArray(m)) ? m : {};
	}

	/**
	 * Set the shared viewing range to the last N days and reload both panes.
	 * Only what is shown/matched follows this — the bank import itself always
	 * pulls a full year server-side.
	 */
	sfSetImportWindow(days: number): void {
		const end = new Date();
		const start = new Date();
		start.setDate(start.getDate() - days);
		this.datefrom.setValue(start);
		this.dateto.setValue(end);
		this.loadSimplefinFeed();
		this.sfLoadErpRows(true);
	}

	/**
	 * The View chips are always relative to today, so there was no way to look at
	 * a fixed past window (e.g. a specific statement month) once enough time had
	 * passed — the Integrations tab had a date-range picker input bound to the
	 * shared datefrom/dateto controls, but nothing ever reloaded off it. Fired once
	 * both ends of a custom range are picked.
	 */
	sfApplyCustomRange(): void {
		if (!this.datefrom.value || !this.dateto.value) { return; }
		this.loadSimplefinFeed();
		this.sfLoadErpRows(true);
	}

	/** Whether the shared range currently equals "last N days ending today". */
	sfImportWindowActive(days: number): boolean {
		const end = new Date();
		const start = new Date();
		start.setDate(start.getDate() - days);
		return this.sfFormatYmd(this.dateto.value) === this.sfFormatYmd(end)
			&& this.sfFormatYmd(this.datefrom.value) === this.sfFormatYmd(start);
	}

	sfLastImportDate(): Date | null {
		return this.sf.lastImport && this.sf.lastImport.at ? new Date(this.sf.lastImport.at * 1000) : null;
	}

	/**
	 * Pull bank transactions into the local feed. Sends no range — the server
	 * imports a full year (idempotent upsert), independent of what is being
	 * viewed. The visible panes are then re-read for the on-screen range.
	 */
	simplefinSync(): void {
		this.sf.syncing = true;
		this.sf.message = '';
		this.sfCloseMatch();
		this.paymentsService.simplefinSync({}).subscribe(
			(res: any) => {
				this.sf.syncing = false;
				if (res && res.success) {
					this.sf.errors = res.errors || [];
					this.sf.lastImport = res.lastImport || this.sf.lastImport;
					const neu = res.imported != null ? res.imported : (res.count || 0);
					const upd = res.updated || 0;
					const window = res.lastImport ? (res.lastImport.start + ' → ' + res.lastImport.end) : 'the last year';
					this.sf.message = 'Import finished: ' + neu + ' new, ' + upd + ' updated, '
						+ (res.count || 0) + ' total from the bank (' + window + ').';
					this.loadSimplefinFeed();
				} else {
					this.sf.message = (res && res.error) ? res.error : 'Sync failed.';
				}
			},
			() => { this.sf.syncing = false; this.sf.message = 'Sync failed.'; }
		);
	}

	/** Load already-imported feed rows (with saved match state) — no bank call. */
	loadSimplefinFeed(): void {
		this.sfFeedLoading = true;
		this.sfCloseMatch();
		const range = { start: this.sfFormatYmd(this.datefrom.value), end: this.sfFormatYmd(this.dateto.value) };
		this.paymentsService.simplefinFeed(range).subscribe(
			(res: any) => {
				this.sfFeedLoading = false;
				if (res && res.success) {
					this.sf.transactions = this.sfNormalizeFeedRows(res.transactions || []);
					this.sfRebuildMatchIdx();
				}
			},
			() => { this.sfFeedLoading = false; }
		);
	}

	simplefinDisconnect(): void {
		if (!confirm('Disconnect SimpleFIN? The stored access credentials will be removed.')) { return; }
		this.paymentsService.simplefinDisconnect().subscribe(
			(res: any) => {
				if (res && res.success) {
					this.sf.connected = false;
					this.sf.accounts = [];
					this.sf.transactions = [];
					this.sf.message = 'Disconnected.';
				}
			},
			() => {}
		);
	}

	sfBankLabel(code: string): string {
		const a = (this.sf.bankAccounts || []).find((b: any) => b.accountcode === code);
		return a ? a.bankaccountname : code;
	}

	/** Which ERP bank account an ERP ledger row belongs to (falls back to the selected account). */
	sfErpAcctCode(t: any): string {
		return String((t && (t.bankact || t.account)) || this.selectedBankAccount.value || '');
	}

	/** Compact per-card bank-account tag: the trailing account number (e.g. "0011"), else the name/code. */
	sfAcctChip(code: string): string {
		const c = String(code || '');
		if (!c) { return ''; }
		const src = (this.sf.bankAccounts && this.sf.bankAccounts.length ? this.sf.bankAccounts : this.bankAccounts) || [];
		const a = src.find((b: any) => String(b.accountcode) === c);
		const name = a ? String(a.bankaccountname || a.bankaccountnumber || c) : c;
		const m = /(\d{3,})\s*$/.exec(name);
		return m ? m[1] : name;
	}

	private round2(n: number): number { return Number.isFinite(n) ? Math.round(n * 100) / 100 : NaN; }
	private sfDateMs(d: any): number {
		if (!d) { return 0; }
		const value = String(d).trim();
		let m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
		if (m) { return new Date(+m[1], +m[2] - 1, +m[3]).getTime(); }
		m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value);
		if (m) {
			// ERP display dates follow the tenant format; MOOV is day/month/year.
			return new Date(+m[3], +m[2] - 1, +m[1]).getTime();
		}
		const dt = new Date(value);
		return isNaN(dt.getTime()) ? 0 : dt.getTime();
	}

	private sfNameTokens(value: any): string[] {
		const stop: { [word: string]: boolean } = {
			type: true, ach: true, single: true, payment: true, payments: true, deposit: true,
			withdrawal: true, invoice: true, bills: true, distro: true, moov: true, company: true,
			cannabis: true, dispensary: true, llc: true, inc: true, corp: true, co: true, ny: true,
			from: true, bank: true, check: true, cash: true, direct: true, name: true, web: true, pay: true
		};
		const words = String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(/\s+/);
		return Array.from(new Set(words.filter((word: string) => word.length >= 3 && !stop[word])));
	}

	/** Business-name evidence used to disambiguate repeated amounts such as $1,800. */
	private sfNameScore(description: any, erpName: any): number {
		const bank = this.sfNameTokens(description);
		const erp = this.sfNameTokens(erpName);
		if (!bank.length || !erp.length) { return 0; }
		let overlap = 0;
		for (const token of erp) {
			if (bank.indexOf(token) !== -1) { overlap++; }
		}
		const bankCompact = bank.join('');
		const erpCompact = erp.join('');
		const contains = bankCompact.length >= 5 && erpCompact.length >= 5
			&& (bankCompact.indexOf(erpCompact) !== -1 || erpCompact.indexOf(bankCompact) !== -1);
		return overlap * 10 + (contains ? 5 : 0);
	}

	/**
	 * Window for the mutual-nearest rule, in days. Must stay well inside the shortest
	 * repeat cycle it has to separate — payroll is weekly, and real pairs land at lag
	 * 0-1 while the nearest wrong candidate is a cycle away. Widening this toward 7
	 * would start matching one payroll run against the next.
	 */
	private readonly SF_TIGHT_MATCH_DAYS = 3;

	/**
	 * True when the pairing is each other's closest date: no other ERP row of this
	 * amount sits as near the feed line, and no other unused feed line of this amount
	 * sits nearer that ERP row. One-sided nearness proves nothing when the amount
	 * recurs — both sides have to agree.
	 *
	 * Same-date ties are allowed: two identical postings on one day (a payroll run with
	 * two 401k loan lines) are interchangeable, so either pairing is equally correct.
	 * A tie across different dates is genuinely ambiguous and refused.
	 */
	private sfNearestOnBothSides(top: any, runner: any, feedRow: any, amt: number, sfList: any[], pool: any[]): boolean {
		const dayMs = 86400000;
		if (top.diff > this.SF_TIGHT_MATCH_DAYS * dayMs) { return false; }
		// ERP side: nothing else as close, unless it falls on the same date.
		if (runner && runner.diff <= top.diff) {
			const topDate = String(top.c.t.trandateYmd || top.c.t.trandate || '');
			const runDate = String(runner.c.t.trandateYmd || runner.c.t.trandate || '');
			if (!topDate || topDate !== runDate) { return false; }
		}
		// Feed side: no other unmatched feed line of this amount is nearer the ERP row.
		const erpTime = top.c.time;
		for (const other of sfList) {
			if (other === feedRow || other.matched || other.ignored) { continue; }
			if (this.round2(Number(other.amount)) !== amt) { continue; }
			const d = Math.abs(this.sfDateMs(other.postedYmd || other.posted) - erpTime);
			if (d < top.diff) { return false; }
		}
		return true;
	}

	/** Loaded rec rows that can still be cleared (uncleared, unlocked, real banktrans). */
	private sfClearableRecRows(): any[] {
		const rows = (this.payments && this.payments.transactions) ? this.payments.transactions : [];
		return rows.filter((t: any) => !t.isCleared && !t.clearedLocked && this.bankTransId(t) > 0 && !this.sfIsInternalReversal(t));
	}

	/** Same-day, same-account equal-and-opposite ERP rows cancel internally. */
	private sfRebuildInternalReversals(): void {
		const rows = (this.payments?.transactions || []) as any[];
		const ids = new Set<number>();
		const buckets: { [key: string]: { positive: any[]; negative: any[] } } = {};
		for (const t of rows) {
			const amount = this.round2(Number(t.amount));
			const id = this.bankTransId(t);
			if (!id || !amount) { continue; }
			const account = String(t.debtorno || t.supplierno || '').trim();
			const date = String(t.trandateYmd || t.trandate || '').trim();
			if (!account || !date) { continue; }
			const key = [String(t.type || ''), account, date, Math.abs(amount).toFixed(2)].join('|');
			if (!buckets[key]) { buckets[key] = { positive: [], negative: [] }; }
			(amount > 0 ? buckets[key].positive : buckets[key].negative).push(t);
		}
		Object.keys(buckets).forEach((key: string) => {
			const bucket = buckets[key];
			const pairs = Math.min(bucket.positive.length, bucket.negative.length);
			for (let i = 0; i < pairs; i++) {
				ids.add(this.bankTransId(bucket.positive[i]));
				ids.add(this.bankTransId(bucket.negative[i]));
			}
		});
		this.sfInternalReversalIds = ids;
	}

	sfIsInternalReversal(t: any): boolean {
		return this.sfInternalReversalIds.has(this.bankTransId(t));
	}

	/** Tick the matched ERP rows cleared via the existing clear flow, then refresh. */
	private sfClearMatched(rows: any[]): void {
		if (!rows.length) { this.applyFilters(); return; }
		rows.forEach((t: any) => { t.isCleared = true; t.amountCleared = this.getClearedAmount(t); });
		const obs = rows.map((t: any) => this.paymentsService.updateTransaction(t));
		forkJoin(obs).subscribe({
			next: (responses: any[]) => {
				rows.forEach((t: any, i: number) => {
					const r = responses[i];
					if (r) {
						t.isCleared = !!r.isCleared;
						t.amountCleared = r.amountCleared != null ? r.amountCleared : t.amountCleared;
						if (typeof r.clearedLocked !== 'undefined') { t.clearedLocked = !!r.clearedLocked; }
					}
				});
				this.applyFilters();
			},
			error: () => { this.applyFilters(); }
		});
	}

	/**
	 * Deterministic auto-match: pair each SimpleFIN transaction (for the selected
	 * bank account) with a loaded rec row of the SAME signed amount whose date is
	 * within SF_MATCH_DAYS. Greedy 1:1 (each bank row consumed once, closest date
	 * wins) so a confident match clears the ERP row.
	 */
	autoMatchSimplefin(): void {
		const account = String(this.selectedBankAccount.value || '');
		if (!account) { this.sf.message = 'Select a bank account on the Reconciliation tab first.'; return; }
		const sfList = (this.sf.transactions || []).filter((s: any) => String(s.erp_bankact) === account && !s.matched && !s.ignored && !s.feedPosted);
		if (!sfList.length) { this.sf.message = 'No unmatched SimpleFIN transactions for this account.'; return; }

		const clearable = this.sfClearableRecRows();
		if (!clearable.length) {
			this.sf.message = 'No uncleared bank rows loaded. On the Reconciliation tab, load this account/date range (Ledger = AR + AP for full coverage) first.';
			return;
		}
		this.sfMatching = true;
		const pool = clearable.map((t: any) => ({
			t, used: false, amt: this.round2(parseFloat(t.amount)), time: this.sfDateMs(t.trandateYmd || t.trandate)
		}));
		const toClear: any[] = [];
		const matchedRows: any[] = [];
		const windowMs = this.SF_MATCH_DAYS * 86400000;

		// Uniqueness has to hold on BOTH sides. The ERP-side test below is not enough on
		// its own: a lone $324 ERP row looks unambiguous while the feed holds fourteen
		// unmatched $324 lines, and this loop walks the FEED, so whichever one comes first
		// takes it — that is how an AmeriCU mobile deposit ended up on a receipt posted
		// from an ACH line of the same amount. Count the feed side up front and demand the
		// same name evidence when it repeats.
		const feedSameAmount: { [k: string]: number } = {};
		for (const s of sfList) {
			const k = this.round2(Number(s.amount)).toFixed(2);
			feedSameAmount[k] = (feedSameAmount[k] || 0) + 1;
		}

		for (const s of sfList) {
			const samt = this.round2(Number(s.amount));
			const stime = this.sfDateMs(s.postedYmd || s.posted);
			const candidates: any[] = [];
			for (const c of pool) {
				if (c.used || c.amt !== samt) { continue; }
				const diff = Math.abs(c.time - stime);
				if (diff <= windowMs) {
					candidates.push({ c, diff, nameScore: this.sfNameScore(s.description, c.t.name) });
				}
			}
			candidates.sort((a: any, b: any) => b.nameScore - a.nameScore || a.diff - b.diff);
			// A unique amount is safe by amount/date alone. Repeated amounts — on either
			// side — require positive business-name evidence and a clear best candidate.
			const top = candidates[0];
			const runner = candidates[1];
			const unique = candidates.length === 1 && (feedSameAmount[samt.toFixed(2)] || 0) <= 1;
			// Recurring postings (payroll) repeat the same amount every cycle, so neither
			// side is ever unique and neither rule above can fire — yet the pairing is not
			// ambiguous: the true partner sits 0-1 days away while the next candidate is a
			// whole cycle out. Mutual nearness inside a window well inside that cycle
			// separates them without a name signal, which these lines do not have
			// ("PRINCIPAL PERIS PLIC-PERIS" vs "401k Payable (loan)").
			const nearest = !unique && top && this.sfNearestOnBothSides(top, runner, s, samt, sfList, pool);
			const best = top && (unique || nearest || (top.nameScore > 0 && (!runner || top.nameScore > runner.nameScore))) ? top.c : null;
			if (best) {
				best.used = true;
				this.sfApplyRowMatch(s, best.t, false, '');
				toClear.push(best.t);
				matchedRows.push(s);
			} else {
				s.matched = false;
			}
		}

		this.sfMatching = false;
		this.sfRebuildMatchIdx();
		this.sf.message = matchedRows.length + ' auto-matched, ' + (sfList.length - matchedRows.length) + ' left.';
		this.sfPersistMatches(matchedRows, 'auto');
		this.sfClearMatched(toClear);
	}

	sfUnmatchedCount(): number {
		const account = String(this.selectedBankAccount.value || '');
		return (this.sf.transactions || []).filter((s: any) => String(s.erp_bankact) === account && !s.matched && !s.ignored && !s.feedPosted).length;
	}

	/**
	 * Feed rows carry a matchList: every (banktransid, transno) pairing on the
	 * row. Older server responses only have the single match fields — normalize
	 * both shapes so the rest of the component reasons about matchList alone.
	 */
	private sfNormalizeFeedRows(rows: any[]): any[] {
		for (const s of rows) {
			if (Array.isArray(s.matches) && s.matches.length) {
				s.matchList = s.matches;
			} else if (s.matched && s.matchBankTransId > 0) {
				s.matchList = [{ banktransid: s.matchBankTransId, transno: s.matchTransno, method: s.matchAi ? 'ai' : 'manual', reason: s.matchReason || '' }];
			} else {
				s.matchList = [];
			}
			this.sfDeriveRowMatchFields(s);
		}
		return rows;
	}

	/** Keep the row's display fields (matched flag, label, first btid) in sync with matchList. */
	private sfDeriveRowMatchFields(s: any): void {
		const list = Array.isArray(s.matchList) ? s.matchList : [];
		s.matched = list.length ? true : (s.matched === false ? false : null);
		s.matchBankTransId = list.length ? Number(list[0].banktransid) : 0;
		s.matchTransno = list.length ? (String(list[0].transno) + (list.length > 1 ? ' +' + (list.length - 1) : '')) : '';
		s.matchAi = list.some((m: any) => m.method === 'ai');
		if (!list.length) { s.matchReason = ''; }
	}

	/** Record one bank↔ERP pairing on the feed row (local only; persist separately). */
	private sfApplyRowMatch(s: any, t: any, ai: boolean, reason: string): void {
		if (!Array.isArray(s.matchList)) { s.matchList = []; }
		const btid = this.bankTransId(t);
		if (!s.matchList.some((m: any) => Number(m.banktransid) === btid)) {
			s.matchList.push({ banktransid: btid, transno: t.transno, method: ai ? 'ai' : 'manual', reason: reason || '' });
		}
		s.matchReason = reason || s.matchReason || '';
		this.sfDeriveRowMatchFields(s);
	}

	/** Persist every pairing on the given feed rows so matches survive reloads. */
	private sfPersistMatches(rows: any[], method: 'auto' | 'ai' | 'manual', allowShared = false): void {
		if (!rows.length) { return; }
		const matches: any[] = [];
		for (const s of rows) {
			for (const m of (s.matchList || [])) {
				matches.push({
					sf_account: s.sf_account, sf_id: s.sf_id,
					transno: m.transno, banktransid: m.banktransid,
					method, reason: s.matchReason || m.reason || ''
				});
			}
		}
		if (!matches.length) { return; }
		this.paymentsService.simplefinSaveMatches({ matches, allow_shared: allowShared }).subscribe(
			(res: any) => {
				if (res && res.success === false && res.error) { this.sf.message = res.error; this.loadSimplefinFeed(); }
			},
			() => {}
		);
	}

	private sfCloseMatch(): void {
		if (this.sfMatchModalRef) {
			this.sfMatchModalRef.close();
			this.sfMatchModalRef = undefined;
		}
		this.sfSelectedBank = null;
		this.sfSelErp = [];
		this.sfHoverLink = 0;
		this.sfHoverFeed = null;
		this.sfMatchExpanded = false;
	}

	toggleSfMatchExpanded(): void {
		this.sfMatchExpanded = !this.sfMatchExpanded;
		const win = document.querySelector('.sf-match-modal-window');
		if (win) { win.classList.toggle('sf-match-modal-expanded', this.sfMatchExpanded); }
	}

	sfPostSelectedBank(): void {
		const row = this.sfSelectedBank;
		if (!row || row.matched || row.ignored || Number(row.amount) >= 0) { return; }
		this.sfCloseMatch();
		this.sfOpenPosting(row);
	}

	/** Deposit equivalent of sfPostSelectedBank: post a customer receipt from the modal. */
	sfReceiptSelectedBank(): void {
		const row = this.sfSelectedBank;
		if (!row || row.matched || row.ignored || Number(row.amount) <= 0) { return; }
		this.sfCloseMatch();
		this.sfOpenReceipt(row);
	}

	toggleSfExpanded(): void {
		this.sfExpanded = !this.sfExpanded;
	}

	@HostListener('document:keydown.escape')
	onSfEscape(): void {
		if (this.sfPostingRow) { this.sfClosePosting(); return; }
		if (this.sfReceiptRow) { this.sfCloseReceipt(); return; }
		if (this.sfSelectedBank) {
			this.sfCloseMatch();
			return;
		}
		if (this.sfSelBank.length) { this.sfClearBankSel(); return; }
		if (this.sfExpanded) { this.sfExpanded = false; }
	}

	sfOpenPosting(s: any): void {
		this.sfPostingRow = s;
		this.sfPostingMode = 'find';
		this.sfPostingVendor = null;
		this.sfVendorResults = [];
		this.sfVendorSearch = this.sfPostingSuggestedName(s.description);
		this.sfExpanded = true;
		this.sfSearchVendors();
		setTimeout(() => document.querySelector('.sf-post-drawer')?.scrollIntoView({ block: 'start', behavior: 'smooth' }), 50);
	}

	sfClosePosting(): void {
		this.sfPostingRow = null;
		this.sfPostingVendor = null;
		this.sfVendorResults = [];
		this.sfPostingMode = 'find';
	}

	/* ---------- money-in: post a customer receipt from a bank deposit ---------- */

	sfOpenReceipt(s: any): void {
		if (!s || s.matched || s.ignored || s.feedPosted || !(Number(s.amount) > 0)) { return; }
		this.sfClosePosting();
		this.sfReceiptRow = s;
		this.sfReceiptCustomer = null;
		this.sfReceiptAr = null;
		this.sfReceiptResults = [];
		this.sfReceiptSubmitting = false;
		this.sfReceiptReference = String(s.description || '').slice(0, 50);
		// Default to what the bank says this deposit WAS — a mobile/CK-DEP line is a
		// deposited check, a TYPE: ACH line is an ACH credit. Never a card method: this
		// records money already received at the bank. The operator can still override.
		this.sfReceiptPaymentType = this.sfPaymentTypeFor(this.sfTenderFromDescription(s.description));
		this.sfReceiptSearch = this.sfPostingSuggestedName(s.description);
		this.sfExpanded = true;
		this.sfSearchReceiptCustomers();
		// The drawer renders in both the Integrations and AR panes — scroll the visible one.
		setTimeout(() => document.querySelector('.bank-rec-tabpane:not([hidden]) .sf-post-drawer')?.scrollIntoView({ block: 'start', behavior: 'smooth' }), 50);
	}

	sfCloseReceipt(): void {
		this.sfReceiptRow = null;
		this.sfReceiptCustomer = null;
		this.sfReceiptAr = null;
		this.sfReceiptResults = [];
	}

	/**
	 * Customer search for the receipt drawer.
	 *
	 * An ACH payer name is often the paying entity, not the name on the account
	 * — "MJ Dispensary" hits directly, but "XANDER LEGACY LL" has to fall back to
	 * "XANDER" to find "By Any Other Name (Xander)", whose trade name is a
	 * parenthetical DBA. So: search what was asked for, and only if that comes
	 * back empty, retry once on the most distinctive word. A dead search with a
	 * prefilled box is a wasted click on someone's actual workload.
	 */
	sfSearchReceiptCustomers(): void {
		const q = (this.sfReceiptSearch || '').trim();
		if (this.sfReceiptSearchSub) { this.sfReceiptSearchSub.unsubscribe(); }
		if (!q) { this.sfReceiptResults = []; this.sfReceiptSearchFallback = ''; return; }
		this.sfReceiptLoading = true;
		this.sfReceiptSearchFallback = '';
		// Widen only on a miss, and stop at the first term that finds anyone.
		const ladder = this.sfArSearchLadder(q);
		if (!ladder.length || ladder[0].toUpperCase() !== q.toUpperCase()) { ladder.unshift(q); }
		const attempt = (i: number) => {
			if (i >= ladder.length) { this.sfReceiptLoading = false; this.sfReceiptResults = []; return; }
			const term = ladder[i];
			this.sfReceiptSearchSub = this.customerService.getCustomerSearch({ keywords: term }).subscribe(
				(results: any) => {
					const hits = Array.isArray(results) ? results : [];
					if (!hits.length) { attempt(i + 1); return; }
					this.sfReceiptLoading = false;
					this.sfReceiptSearchFallback = (i === 0) ? '' : term;
					this.sfReceiptResults = hits.slice(0, 20);
				},
				() => { this.sfReceiptLoading = false; this.sfReceiptResults = []; }
			);
		};
		attempt(0);
	}

	sfSelectReceiptCustomer(c: any): void {
		this.sfReceiptCustomer = c;
		this.sfReceiptAr = null;
		this.paymentsService.getCustomerAccountReceivables(c.debtorno, c.branchcode).subscribe(
			(ar: any) => { if (this.sfReceiptCustomer === c) { this.sfReceiptAr = ar || null; } },
			() => {}
		);
	}

	sfSubmitReceipt(): void {
		const s = this.sfReceiptRow;
		const c = this.sfReceiptCustomer;
		if (!s || !c || this.sfReceiptSubmitting) { return; }
		if (!this.sfReceiptPaymentType) { this.sf.message = 'Pick a payment type first.'; return; }
		const payment = {
			debtorno: c.debtorno,
			branchcode: c.branchcode,
			payment_type: this.sfReceiptPaymentType,
			bankaccount: String(this.selectedBankAccount.value || s.erp_bankact || ''),
			datepaid: s.postedYmd || s.posted,
			checkno: '',
			reference: this.sfReceiptReference || String(s.sf_id || ''),
			description: 'Bank rec: ' + String(s.description || s.sf_id || ''),
			amount: this.round2(Number(s.amount)),
			discount: 0,
			currency: (this.sfReceiptAr && this.sfReceiptAr.currcode) || c.currcode || 'USD',
			journalno: '1',
		};
		this.sfReceiptSubmitting = true;
		this.paymentsService.addCashRecPayment({ payment, charge_card: false }).subscribe(
			(res: any) => {
				this.sfReceiptSubmitting = false;
				if (res && res.success) {
					this.sf.message = 'Receipt posted'
						+ (res.auto_allocated_matching_invoice ? ' and allocated to matching open invoice(s)' : '')
						+ '. Matching it to the bank line…';
					// Teach the proposal engine this payer → customer for next import.
					this.paymentsService.simplefinLearnAlias({
						description: String(s.description || ''),
						debtorno: c.debtorno,
						branchcode: c.branchcode,
						cust_name: c.brname || c.name || '',
					}).subscribe(() => { }, () => { });
					this.sfCloseReceipt();
					this.sfLinkPostedReceipt(s, res.payment && res.payment.transno ? res.payment.transno : '');
					this.sfPendingPairRow = s;
					this.sfAfterErpLoad = () => this.sfPairPostedRow();
					this.sfLoadErpRows(true);
					// The AR tiers are built once by sfArPropose and never invalidated, so a
					// deposit posted from this drawer stayed in the manual list looking unpaid
					// — the operator posts it, it comes straight back, and the obvious next
					// move is to post it again. Reclassify against the ledger we just wrote.
					this.sfArRefreshAfterPost();
				} else {
					this.sf.message = 'Receipt failed: ' + ((res && res.message) || 'unknown error');
				}
			},
			() => { this.sfReceiptSubmitting = false; this.sf.message = 'Receipt failed (request error).'; }
		);
	}

	/** After posting, pair the feed row to the freshly created same-amount ERP row. */
	private sfPairPostedRow(): void {
		const s = this.sfPendingPairRow;
		this.sfPendingPairRow = null;
		if (!s || s.matched) { return; }
		if (this.sfPairOneRow(s)) {
			this.sf.message = 'Posted and matched to the bank line.';
		} else {
			this.sf.message = 'Posted — the new ERP row was not found for auto-matching; match it manually.';
		}
	}

	/**
	 * Record the AR receipt a feed row produced, in bank_feed_post_links — the same
	 * store simplefinSetPosted() already keeps for GL journals, and which the server
	 * reads back as this row's AR reference (COALESCE(l.transno, p.post_transno) against
	 * debtortrans type 12, e.g. in simplefinSeedAliases). post_kind 'receipt' so the row
	 * labels itself "Posted from feed (receipt)" instead of looking unaccounted for.
	 *
	 * Provenance, not reconciliation: the receipt's banktrans still needs its match link
	 * and clearing, which sfPairOneRow() does next — but now against a KNOWN transno
	 * rather than by hunting a same-amount ERP row.
	 */
	private sfLinkPostedReceipt(s: any, transno: any): void {
		const tn = Number(transno || 0);
		if (!s || !tn) { return; }
		// Held locally too: pairing runs before the feed reload that would bring it back.
		s.feedPostTransno = tn;
		this.paymentsService.simplefinSetPosted({
			sf_account: s.sf_account,
			sf_id: s.sf_id,
			post_type: 12,
			post_transno: tn,
			post_kind: 'receipt',
		}).subscribe(
			(saved: any) => {
				if (!saved || !saved.success) {
					this.sf.message = 'Receipt posted, but its bank-feed reference was not saved.';
				}
			},
			() => { this.sf.message = 'Receipt posted, but its bank-feed reference was not saved.'; }
		);
	}

	/**
	 * Pair one posted feed row to the ERP row that WAS posted from it.
	 *
	 * The post link names the receipt outright, so match on it. Falling back to "newest
	 * unmatched same-amount ERP row" is a guess, and on a page of identical amounts it
	 * guesses wrong: six different customers' $324 deposits all landed on one $324
	 * receipt (7/29 batch), consuming deposits that still owed their own receipts. The
	 * fallback stays for rows posted outside this session (no post link), but only when
	 * the amount is UNAMBIGUOUS — one candidate. Two identical candidates is precisely
	 * when a guess is worthless, so leave it for the operator instead of picking the
	 * newest.
	 */
	private sfPairOneRow(s: any): boolean {
		if (!s || s.matched) { return false; }
		const amt = this.round2(Number(s.amount));
		const rows = (this.payments && this.payments.transactions) ? this.payments.transactions : [];
		const open = rows.filter((t: any) => !this.sfErpMatch(t) && !t.clearedLocked && this.bankTransId(t) > 0);
		const posted = String(s.feedPostTransno || '');
		if (posted !== '') {
			const exact = open.find((t: any) => String(t.transno) === posted);
			if (exact) { this.sfCompleteMatch([s], [exact]); return true; }
			// The named receipt isn't in the loaded ERP window — pairing by amount here
			// would attach someone else's. Leave it; the post link still records what this
			// deposit produced, so the row cannot be proposed for a second receipt.
			return false;
		}
		const candidates = open.filter((t: any) => this.round2(parseFloat(t.amount)) === amt);
		if (candidates.length !== 1) { return false; }
		this.sfCompleteMatch([s], [candidates[0]]);
		return true;
	}

	/** Batch version: pair every just-posted feed row; each match consumes its candidate. */
	private sfPairPostedRows(): void {
		const rows = this.sfPendingPairRows.splice(0);
		if (!rows.length) { return; }
		let paired = 0;
		for (const s of rows) {
			if (this.sfPairOneRow(s)) { paired++; }
		}
		this.sf.message = 'Receipts posted: ' + paired + '/' + rows.length + ' matched to bank lines'
			+ (paired < rows.length ? ' — pair the rest manually.' : '.');
	}

	/* ---------- AR automation: propose + batch-post receipts from deposits ---------- */

	/** Open the AR receipts tab; bootstrap the feed connection and proposals on first visit. */
	setArTab(): void {
		this.activeTab = 'ar';
		if (!this.sf.loaded) { this.loadSimplefinStatus(); }
		if (!this.sfAr.loaded && !this.sfAr.loading) { this.sfArPropose(); }
		// The log drives the proposals, so it is worth having its count in hand
		// even while the section is collapsed.
		this.sfLogLoad();
	}

	/** A statement was imported or a past drop undone — pull the feed (and, since
	 * undo can un-clear a real banktrans row, the ERP side too) back in. */
	onStatementImported(res: any): void {
		if (!res || (!res.imported && !res.undone)) { return; }

		// A statement is imported against whichever ERP bank account the operator
		// picked INSIDE the importer, which drifts from the main account picker as
		// soon as it's changed there (the importer only seeds its default once).
		// Without this, the just-imported rows land under an account nobody is
		// looking at and the screen reads as empty even though nothing failed.
		let switchedAccount = false;
		if (res.bankaccount && String(res.bankaccount) !== String(this.selectedBankAccount.value || '')) {
			this.selectedBankAccount.setValue(String(res.bankaccount));
			switchedAccount = true;
		}

		// The feed pane loads against the shared date range, which defaults to the
		// first of last month. A statement covering earlier dates imported fine but
		// landed outside the view, so the table looked unchanged and the import read
		// as a no-op. Widen the range to cover what was just imported before
		// reloading, and pull the ERP side in too so both panes line up.
		// Tolerate a time component on the row dates; parse as local midnight so the
		// range doesn't shift a day under a negative UTC offset.
		const ymd = (v: any): string => String(v || '').slice(0, 10);
		const asLocalDate = (s: string): Date => {
			const p = s.split('-');
			return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
		};

		let widened = false;
		const from = ymd(res.postedFrom);
		const to   = ymd(res.postedTo);
		if (/^\d{4}-\d{2}-\d{2}$/.test(from) && this.sfFormatYmd(this.datefrom.value) > from) {
			this.datefrom.setValue(asLocalDate(from));
			widened = true;
		}
		if (/^\d{4}-\d{2}-\d{2}$/.test(to) && this.sfFormatYmd(this.dateto.value) < to) {
			this.dateto.setValue(asLocalDate(to));
			widened = true;
		}

		// A leftover subset filter (from earlier drilldown on this screen) can mask
		// a fresh import just as easily as a stale account or date range can.
		if (this.sfSubsetFrom || this.sfSubsetTo) {
			this.sfSubsetFrom = '';
			this.sfSubsetTo = '';
		}

		this.loadSimplefinFeed();
		if (res.undone || widened || switchedAccount) { this.sfLoadErpRows(true); }
	}

	/** Change the proposal window from the AR tab (shared range) and re-propose. */
	sfArSetWindow(days: number): void {
		this.sfSetImportWindow(days);
		this.sfArPropose();
	}

	/**
	 * Re-run the classification after money is posted, so a row that is now a real
	 * receipt leaves the manual list instead of inviting a second posting. Only when
	 * the AR tab has actually been loaded — this must not fetch for someone who never
	 * opened it. Debounced because a batch post calls it once per row.
	 */
	private sfArRefreshAfterPost(): void {
		if (!this.sfAr.loaded || this.sfAr.posting) { return; }
		if (this.sfArRefreshTimer) { clearTimeout(this.sfArRefreshTimer); }
		this.sfArRefreshTimer = setTimeout(() => { this.sfArRefreshTimer = null; this.sfArPropose(); }, 400);
	}

	/** Classify unmatched deposits in the viewed range (read-only, server-side). */
	sfArPropose(): void {
		this.sfAr.loading = true;
		this.sfAr.message = '';
		const range = { start: this.sfFormatYmd(this.datefrom.value), end: this.sfFormatYmd(this.dateto.value) };
		this.paymentsService.simplefinProposeReceipts(range).subscribe(
			(res: any) => {
				this.sfAr.loading = false;
				if (res && res.success) {
					this.sfAr.loaded = true;
					// Pre-check ready rows (exact + near-exact). Genuine duplicates are
					// now routed to the attention tier, so ready is safe to pre-select.
					// Amount-tie matches (payer_unconfirmed) surface here but stay UNchecked
					// so a bulk "Create" never posts an unconfirmed payer — operator ticks each.
					this.sfAr.ready = (res.ready || []).map((r: any) => ({ ...r, _sel: !r.payer_unconfirmed }));
					this.sfAr.review = res.review || [];
					this.sfAr.attention = res.attention || [];
					this.sfAr.unresolved = res.unresolved || [];
					this.sfAr.nonCustomer = res.nonCustomer || [];
					this.sfAr.counts = res.counts || null;
					// Auto-open the review (partial) tier when there is nothing in ready —
					// otherwise the most-common case lands on a blank screen.
					if (!this.sfAr.ready.length && this.sfAr.review.length) {
						this.sfAr.reviewOpen = true;
					}
				} else {
					this.sfAr.message = (res && res.error) ? res.error : 'Could not load proposals.';
				}
			},
			() => { this.sfAr.loading = false; this.sfAr.message = 'Could not load proposals.'; }
		);
	}

	/* ---------- check log (expected payments) ---------- */

	/** Live log lines. Server attaches each target invoice's current balance, so a
	 *  line whose invoice got settled another way comes back flagged `stale`. */
	sfLogLoad(force = false): void {
		if (this.sfLog.loading || (this.sfLog.loaded && !force)) { return; }
		this.sfLog.loading = true;
		this.sfLog.message = '';
		this.paymentsService.expectedPaymentsList({}).subscribe(
			(res: any) => {
				this.sfLog.loading = false;
				if (res && res.success) {
					this.sfLog.loaded = true;
					this.sfLog.rows = res.rows || [];
				} else {
					this.sfLog.message = (res && res.error) ? res.error : 'Could not load the check log.';
				}
			},
			() => { this.sfLog.loading = false; this.sfLog.message = 'Could not load the check log.'; }
		);
	}

	/* --- photo intake: drop the log page, review, then save --- */

	sfLogPickShot(event: any): void { this.sfLogReadFile(event?.target?.files?.[0]); }

	/**
	 * Paste a screenshot straight in (Cmd/Ctrl-V) — how a phone photo usually
	 * arrives once it's been AirDropped or snipped, without a round trip to disk.
	 *
	 * Guarded so it can never swallow a normal paste: only while the AR tab is
	 * showing with the log open, never while the caret is in a field, and only
	 * when the clipboard actually carries an image (pasting text is left alone).
	 */
	@HostListener('document:paste', ['$event'])
	sfLogPaste(event: ClipboardEvent): void {
		if (this.activeTab !== 'ar' || !this.sfLog.open || this.sfShot.reading) { return; }
		const el = event.target as HTMLElement | null;
		if (el && (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) || el.isContentEditable)) { return; }
		const items = event.clipboardData?.items;
		if (!items) { return; }
		for (let i = 0; i < items.length; i++) {
			if (items[i].kind !== 'file' || items[i].type.indexOf('image/') !== 0) { continue; }
			const file = items[i].getAsFile();
			if (file) {
				event.preventDefault();
				// Clipboard images come through nameless; give it something to show.
				this.sfLogReadFile(new File([file], file.name || 'pasted-check-log.png', { type: file.type }));
			}
			return;
		}
	}

	sfLogDragOver(event: DragEvent): void { event.preventDefault(); this.sfShot.over = true; }
	sfLogDragLeave(): void { this.sfShot.over = false; }
	sfLogDrop(event: DragEvent): void {
		event.preventDefault();
		this.sfShot.over = false;
		this.sfLogReadFile(event.dataTransfer?.files?.[0]);
	}

	/** Send the page to the server, which reads it AND resolves every order number. */
	private sfLogReadFile(file: File | null | undefined): void {
		if (!file) { return; }
		const ok = ['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'application/pdf'];
		if (ok.indexOf(file.type) === -1) {
			this.sfShot.message = 'Use a photo (JPEG/PNG/WEBP/GIF) or a PDF.';
			return;
		}
		this.sfShot.reading = true;
		this.sfShot.message = '';
		this.sfShot.rows = [];
		this.sfShot.fileName = file.name;
		const reader = new FileReader();
		reader.onload = () => {
			this.paymentsService.expectedPaymentsFromImage({
				image_base64: String(reader.result || ''), media_type: file.type
			}).subscribe(
				(res: any) => {
					this.sfShot.reading = false;
					if (res && res.success) {
						// Rows arrive pre-ticked only when they resolved cleanly — anything
						// the server flagged needs a human to look before it can be saved.
						/* A name match is never pre-ticked, however confident: pick_issue is set on
						   every row the order numbers did not place, and the operator's tick is
						   what confirms it. */
						this.sfShot.rows = (res.rows || []).map((r: any) => ({
							...r, _readAmount: Number(r.amount) || 0,
							_sel: !!r.resolved && !(r.issues || []).length && !r.pick_issue
						}));
						this.sfShot.counts = res.counts || null;
						this.sfShot.total = res.total || 0;
						this.sfShot.depositDate = res.deposit_date || '';
					} else {
						this.sfShot.message = (res && res.error) ? res.error : 'Could not read that page.';
					}
				},
				() => { this.sfShot.reading = false; this.sfShot.message = 'Could not read that page.'; }
			);
		};
		reader.onerror = () => { this.sfShot.reading = false; this.sfShot.message = 'Could not read that file.'; };
		reader.readAsDataURL(file);
	}

	/** Label for one shortlist entry — the open balance is usually what decides it. */
	sfShotCandLabel(c: any): string {
		const bits = [String(c.name || ''), String(c.debtorno || '')];
		if (Number(c.open_total)) { bits.push(this.round2(Number(c.open_total)).toFixed(2) + ' open'); }
		if (c.amount_tie) { bits.push('matches this check'); }
		if (c.inactive) { bits.push('inactive'); }
		return bits.join(' · ');
	}

	/**
	 * Choose the customer for a row the order numbers could not place.
	 *
	 * Clearing the pick note on change is cosmetic — the note only ever suppressed the
	 * PRE-tick, and the checkbox stays live either way, so a row whose auto-filled match
	 * is already right is confirmed by ticking it rather than by re-choosing it.
	 */
	sfShotPick(row: any, debtorno: string): void {
		const c = (row.candidates || []).find((x: any) => String(x.debtorno) === String(debtorno));
		if (!c) {
			row.debtorno = '';
			row.branchcode = '';
			row.cust_name = row.read_payer || '';
			row._sel = false;
			return;
		}
		row.debtorno = c.debtorno;
		row.branchcode = c.branchcode;
		row.cust_name = c.name;
		row.pick_issue = '';
	}

	/** Savable rows only: expectedPaymentsSave rejects a blank customer or a zero amount. */
	sfShotCanPick(row: any): boolean { return !!row.debtorno && Number(row.amount) > 0; }

	/**
	 * Live, because the amount is keyable: a row the reader could not price is not a
	 * permanent defect, it is a blank waiting to be filled, and a message baked in at
	 * read time would still be sitting there after it had been.
	 */
	sfShotAmountIssue(row: any): string {
		return Number(row.amount) > 0 ? '' : 'No amount was read — key what the check says.';
	}

	/** Untick a row that has just been emptied, so it cannot ride along in a save. */
	sfShotAmountChange(row: any): void {
		if (!(Number(row.amount) > 0)) { row._sel = false; }
	}

	/** What the amount is being checked against: the open balance, or — once the
	 *  invoice is settled and has none — what it was written for. */
	sfShotDocTotal(row: any): number {
		return Number(row.docsOpenTotal) || Number(row.docsFaceTotal) || 0;
	}

	/** The page total follows what is keyed now, not what was first read off the paper. */
	sfShotTotal(): number {
		return this.round2(this.sfShot.rows.reduce((t: number, r: any) => t + (Number(r.amount) || 0), 0));
	}

	sfShotSelCount(): number { return this.sfShot.rows.filter((r: any) => r._sel).length; }
	sfShotSelTotal(): number {
		return this.sfShot.rows.filter((r: any) => r._sel).reduce((t: number, r: any) => t + (Number(r.amount) || 0), 0);
	}
	sfShotDiscard(): void { this.sfShot.rows = []; this.sfShot.message = ''; this.sfShot.fileName = ''; }

	/** Save the ticked rows into the log in one call. */
	sfShotSave(): void {
		const picked = this.sfShot.rows.filter((r: any) => r._sel);
		if (!picked.length) { return; }
		this.sfShot.saving = true;
		this.sfShot.message = '';
		const rows = picked.map((r: any) => ({
			debtorno: r.debtorno, branchcode: r.branchcode, cust_name: r.cust_name,
			amount: Number(r.amount), transnos: r.transnos || [],
			log_date: r.log_date, deposit_batch: r.deposit_batch || this.sfShot.depositDate,
			instrument: (r.instrument || 'check') as 'check' | 'ach' | 'cash' | 'other',
			source: 'photo' as const, notes: r.notes || ''
		}));
		this.paymentsService.expectedPaymentsSave({ rows }).subscribe(
			(res: any) => {
				this.sfShot.saving = false;
				if (res && res.success) {
					this.sfShot.message = 'Added ' + (res.inserted || 0) + ' line' + ((res.inserted === 1) ? '' : 's') + ' to the log.';
					this.sfShot.rows = [];
					this.sfShot.fileName = '';
					this.sfLogLoad(true);
				} else {
					this.sfShot.message = (res && res.errors && res.errors.length) ? res.errors[0] : 'Could not save those lines.';
				}
			},
			() => { this.sfShot.saving = false; this.sfShot.message = 'Could not save those lines.'; }
		);
	}

	sfLogToggle(): void {
		this.sfLog.open = !this.sfLog.open;
		if (this.sfLog.open) { this.sfLogLoad(); }
	}

	/** Blank line. Amount and customer are the only required fields — a log entry
	 *  with no invoice numbers still resolves the payer, which is most of the win. */
	sfLogNew(): void {
		this.sfLog.draft = {
			id: 0, debtorno: '', cust_name: '', branchcode: '', amount: null,
			transnosText: '', creditTransnosText: '', check_no: '', log_date: '', deposit_batch: '',
			instrument: 'check', notes: '', source: 'manual', status: 'expected'
		};
	}

	sfLogEdit(row: any): void {
		this.sfLog.draft = {
			...row,
			transnosText: (row.transnos || []).join(', '),
			creditTransnosText: (row.credit_transnos || []).join(', ')
		};
		// Ensure the check-log section is expanded so the inline edit form is visible.
		this.sfLog.open = true;
	}

	/** True when the given log row is the one currently open for editing. */
	sfLogIsEditing(row: any): boolean {
		return !!(this.sfLog.draft && this.sfLog.draft.id && this.sfLog.draft.id === row.id);
	}

	/** Show the same server-built allocation check used by partial deposits. */
	sfLogPreview(row: any): void {
		if (!row || row._planLoading) { return; }
		if (row._plan) { row._plan = null; return; }
		if (!row.debtorno || !(Number(row.amount) > 0)) {
			this.sfLog.message = 'Add a customer account and positive amount before reviewing allocation.';
			return;
		}
		row._planLoading = true;
		const req: any = {
			debtorno: row.debtorno,
			branchcode: row.branchcode || '',
			amount: this.round2(Number(row.amount)),
		};
		if ((row.transnos || []).length) { req.transnos = row.transnos; }
		if ((row.credit_transnos || []).length) { req.credit_transnos = row.credit_transnos; }
		this.paymentsService.simplefinReceiptPlan(req).subscribe(
			(plan: any) => {
				row._planLoading = false;
				if (plan && plan.success) { row._plan = plan; }
				else { this.sfLog.message = 'Could not build an allocation review for this line.'; }
			},
			() => { row._planLoading = false; this.sfLog.message = 'Could not build an allocation review for this line.'; }
		);
	}

	sfLogCancel(): void { this.sfLog.draft = null; }

	private sfLogParseNums(text: string): number[] {
		return String(text || '').split(',')
			.map((s: string) => parseInt(s.trim(), 10))
			.filter((n: number) => !isNaN(n) && n > 0);
	}

	sfLogSave(): void {
		const d = this.sfLog.draft;
		if (!d) { return; }
		if (!d.debtorno || !(d.amount > 0)) {
			this.sfLog.message = 'A customer account and a positive amount are required.';
			return;
		}
		this.sfLog.saving = true;
		this.sfLog.message = '';
		const row: any = {
			debtorno: d.debtorno, branchcode: d.branchcode || '', cust_name: d.cust_name || '',
			amount: Number(d.amount), transnos: this.sfLogParseNums(d.transnosText),
			credit_transnos: this.sfLogParseNums(d.creditTransnosText),
			instrument: d.instrument || 'check', check_no: d.check_no || '',
			log_date: d.log_date || '', deposit_batch: d.deposit_batch || '',
			source: d.source || 'manual', notes: d.notes || ''
		};
		if (d.id) { row.id = d.id; }
		this.paymentsService.expectedPaymentsSave({ rows: [row] }).subscribe(
			(res: any) => {
				this.sfLog.saving = false;
				if (res && res.success) {
					this.sfLog.draft = null;
					this.sfLogLoad(true);
				} else {
					this.sfLog.message = (res && res.errors && res.errors.length) ? res.errors[0] : 'Could not save the line.';
				}
			},
			() => { this.sfLog.saving = false; this.sfLog.message = 'Could not save the line.'; }
		);
	}

	/**
	 * The ERP payment method for a tender word ('check' | 'cash' | 'ach'), never a card
	 * method — none of this money arrived on a card.
	 *
	 * The fallback everything used to use, "first non-card method", is not a neutral
	 * default: it follows paymentmethods.sort_order, which on MOOV puts Cash first. That
	 * is how 79 of the 80 receipts posted from this screen came to be recorded as Cash
	 * when 24 of them say ACH in their own narrative and none was actually cash. Match on
	 * the name first; fall back only when the tenant has no method by that name.
	 */
	private sfPaymentTypeFor(tender: string): string {
		const methods = this.payment_methods || [];
		const noncard = methods.filter((m: any) => String(m.cc_process) !== '1');
		const want = String(tender || '').toLowerCase();
		const named = (test: (n: string) => boolean) =>
			noncard.find((m: any) => test(String(m.paymentname || '').trim().toLowerCase()));
		let hit: any = null;
		if (want === 'cash') { hit = named((n) => n === 'cash'); }
		else if (want === 'check') { hit = named((n) => n === 'check' || n === 'cheque'); }
		else if (want === 'ach') { hit = named((n) => n.indexOf('ach') !== -1) || named((n) => n === 'wire'); }
		if (hit) { return hit.paymentid; }
		return noncard.length ? noncard[0].paymentid : (methods[0]?.paymentid || '');
	}

	/**
	 * What instrument a deposit actually arrived as, read off the bank's own wording.
	 * Shapes on the MOOV feed: 100 "SB AmeriCU CU Mobile … Deposit #NNNNNN" and 5
	 * "CK-DEP" lines are deposited checks; "TYPE: ACH …" and the other "TYPE:" memos are
	 * ACH credits. Empty when the wording says nothing useful, so the caller keeps its
	 * own default rather than inventing a tender.
	 */
	private sfTenderFromDescription(desc: string): string {
		const d = String(desc || '').toLowerCase();
		if (d.indexOf('mobile') !== -1 && d.indexOf('deposit') !== -1) { return 'check'; }
		if (d.indexOf('ck-dep') !== -1 || d.indexOf('check dep') !== -1) { return 'check'; }
		if (d.indexOf('ach') !== -1 || d.indexOf('bill pmt') !== -1 || d.indexOf('bill_pay') !== -1) { return 'ach'; }
		// "TYPE: <originator's entry description> CO: <company>" is the ACH company-credit
		// format on this feed — 276 of 276 such lines carry the CO: half, so the varied
		// TYPE: wording ("MOOV DISTR", "PAYMENT", a date) is the payer's free text, not a
		// different instrument. Without this the largest slice keeps falling through to the
		// default and lands as Cash again.
		if (d.indexOf('type:') !== -1 && d.indexOf('co:') !== -1) { return 'ach'; }
		return '';
	}

	/**
	 * The bank's deposit-slip number off a check-deposit line ("… Deposit #772169").
	 * It goes on banktrans.ref, which is where the rec's own candidate query looks for a
	 * cheque number — and on a nameless mobile deposit the slip number is the only thing
	 * that ties the ERP row back to a line on the paper log.
	 */
	private sfDepositSlipNo(desc: string): string {
		const m = String(desc || '').match(/#\s*(\d{3,})/);
		return m ? m[1] : '';
	}

	/**
	 * The ERP date for a check/cash receipt. The deposit slip's date is what the bank
	 * will show, so it wins when the line names one; otherwise the date written on the
	 * paper. Both blank (money in hand, no slip yet) falls back to today.
	 */
	private sfLogPostDate(row: any): string {
		const ymd = (v: any): string => {
			const s = String(v || '').slice(0, 10);
			return /^\d{4}-\d{2}-\d{2}$/.test(s) ? s : '';
		};
		return ymd(row.deposit_batch) || ymd(row.log_date) || this.sfFormatYmd(new Date());
	}

	sfLogPostable(): any[] {
		return (this.sfLog.rows || []).filter((r: any) => r.status === 'expected' && !r._posting && !r._posted);
	}

	sfLogPostableTotal(): number {
		return this.sfLogPostable().reduce((t: number, r: any) => t + (Number(r.amount) || 0), 0);
	}

	/**
	 * Post one logged check/cash line as a customer receipt.
	 *
	 * Money in hand, days before the bank shows it — so this is the ONE receipt path that
	 * is not driven by a feed row. It still goes through simplefinReceiptPlan +
	 * payments/add, the same as a deposit posted from the feed, so allocation, GL and the
	 * banktrans row are built by exactly one code path. The line's own transnos ride
	 * along as the plan: naming the invoice is what stops oldest-first from settling a
	 * different one. Afterwards the line is stamped 'keyed', which is what makes the
	 * deposit MATCH this receipt when it finally lands instead of posting a second one.
	 */
	sfLogPost(row: any, done?: () => void): void {
		if (!row || row._posting || row.status !== 'expected') { if (done) { done(); } return; }
		if (!row.debtorno || !(Number(row.amount) > 0)) {
			row._postStatus = 'needs a customer and amount';
			if (done) { done(); }
			return;
		}
		// No feed row to inherit an account from — the picker is the only source, and an
		// empty one would post the receipt against no bank account at all.
		const bankact = String(this.selectedBankAccount.value || '');
		if (bankact === '') {
			row._postStatus = 'pick the bank account first';
			this.sfLog.message = 'Choose the bank account these are being deposited to before posting.';
			if (done) { done(); }
			return;
		}
		row._posting = true;
		row._postStatus = 'posting…';
		const finish = (msg: string, ok: boolean) => {
			row._posting = false;
			row._postStatus = msg;
			if (ok) { row._posted = true; }
			if (done) { done(); }
		};
		const planReq: any = {
			debtorno: row.debtorno, branchcode: row.branchcode || '', amount: this.round2(Number(row.amount)),
		};
		if ((row.transnos || []).length) { planReq.transnos = row.transnos; }
		if ((row.credit_transnos || []).length) { planReq.credit_transnos = row.credit_transnos; }
		this.paymentsService.simplefinReceiptPlan(planReq).subscribe(
			(plan: any) => {
				if (!plan || !plan.success) { finish('failed: no allocation plan', false); return; }
				const instrument = String(row.instrument || 'check');
				const payment = {
					debtorno: row.debtorno,
					branchcode: row.branchcode || '',
					payment_type: this.sfPaymentTypeFor(instrument),
					bankaccount: String(this.selectedBankAccount.value || ''),
					datepaid: this.sfLogPostDate(row),
					checkno: String(row.check_no || ''),
					reference: String(row.check_no || row.cust_name || '').slice(0, 50),
					description: 'Check log: ' + String(row.cust_name || row.debtorno)
						+ (row.check_no ? ' check ' + row.check_no : '')
						+ (row.deposit_batch ? ' (slip ' + row.deposit_batch + ')' : ''),
					amount: this.round2(Number(row.amount)),
					discount: 0,
					currency: plan.currcode || 'USD',
					journalno: '1',
				};
				this.paymentsService.addCashRecPayment({ payment, charge_card: false, to: plan.to || [] }).subscribe(
					(res: any) => {
						if (!res || !res.success) { finish('failed: ' + ((res && res.message) || 'post error'), false); return; }
						const transno = Number(res.payment && res.payment.transno ? res.payment.transno : 0);
						if (!transno) { finish('posted, but no transno came back — stamp the line manually', false); return; }
						// Stamp separately: the receipt exists either way, and a failed stamp
						// must not read as a failed post.
						this.paymentsService.expectedPaymentsKeyed({ id: row.id, transno: transno }).subscribe(
							(k: any) => {
								/* Move the row to the state the server just put it in. Without this
								   the line keeps rendering 'expected' with a 'posted #N' note stapled
								   to it — which reads exactly like a double post to anyone looking at
								   the log, when in fact it is keyed and awaiting its deposit. */
								if (k && k.success) {
									row.status = 'keyed';
									row.posted_transno = transno;
									if (!row.log_date) { row.log_date = this.sfLogPostDate(row); }
								}
								finish((k && k.success)
									? 'posted #' + transno + (Number(plan.onAccount) > 0
										? ' · ' + Number(plan.onAccount).toFixed(2) + ' on account' : '')
									: 'posted #' + transno + ' — log line not stamped: ' + ((k && k.error) || 'unknown'),
									true);
							},
							() => finish('posted #' + transno + ' — log line not stamped (request error)', true)
						);
					},
					() => finish('failed (request error)', false)
				);
			},
			() => finish('failed: plan error', false)
		);
	}

	/** Post every logged line still awaiting its receipt, one at a time. */
	sfLogPostAll(): void {
		if (this.sfLog.posting) { return; }
		const queue = this.sfLogPostable();
		if (!queue.length) { return; }
		this.sfLog.posting = true;
		this.sfLog.postTotal = queue.length;
		this.sfLog.postDone = 0;
		const next = () => {
			const row = queue.shift();
			if (!row) {
				this.sfLog.posting = false;
				this.sfLog.message = 'Posted ' + this.sfLog.postDone + '/' + this.sfLog.postTotal
					+ ' logged payments. They will match their deposits when those land.';
				this.sfLogLoad(true);
				this.sfLoadErpRows(true);
				return;
			}
			this.sfLogPost(row, () => { this.sfLog.postDone++; next(); });
		};
		next();
	}

	/** Void keeps the trail for a line already keyed; a plain expected line is dropped. */
	sfLogDelete(row: any): void {
		const asVoid = row.status === 'keyed' || row.status === 'matched';
		this.paymentsService.expectedPaymentsDelete({ id: row.id, void: asVoid }).subscribe(
			() => this.sfLogLoad(true),
			() => { this.sfLog.message = 'Could not remove the line.'; }
		);
	}

	/**
	 * The log split by lifecycle state. One flat list forced the reader to decode a
	 * status blob on every row to work out whether anything was owed of them; the three
	 * states want three different actions, so they get three sections.
	 */
	sfLogByState(state: string): any[] {
		return (this.sfLog.rows || []).filter((l: any) => String(l.status || '') === state);
	}

	sfLogStateTotal(state: string): number {
		return this.sfLogByState(state).reduce((t: number, r: any) => t + (Number(r.amount) || 0), 0);
	}

	/**
	 * Two or more keyed lines share this amount, so a deposit at that amount cannot say
	 * which check it was. This is the ONLY thing in the log that needs a human, so it is
	 * the only thing flagged — everything else resolves itself when the money lands.
	 */
	sfLogAmbiguous(l: any): boolean {
		if (!l || String(l.status) !== 'keyed') { return false; }
		const cents = Math.round((Number(l.amount) || 0) * 100);
		return (this.sfLog.rows || []).filter((r: any) => String(r.status) === 'keyed'
			&& Math.round((Number(r.amount) || 0) * 100) === cents).length > 1;
	}

	sfLogAmbiguousCount(): number {
		return (this.sfLog.rows || []).filter((l: any) => this.sfLogAmbiguous(l)).length;
	}

	sfLogTotal(): number {
		return this.sfLog.rows.reduce((t: number, r: any) => t + (Number(r.amount) || 0), 0);
	}

	sfLogOpenCount(): number {
		return this.sfLog.rows.filter((r: any) => r.status === 'expected' || r.status === 'keyed').length;
	}

	/**
	 * An `expected_keyed` deposit: the receipt was posted ahead of the money
	 * arriving, so this pairs the feed row to that existing banktrans. It never
	 * creates a second receipt — that is the whole point of the branch.
	 */
	sfArResolveExpected(r: any, done?: () => void): void {
		const e = r && r.expectedResolve;
		if (!e) { if (done) { done(); } return; }
		r._status = 'matching…';
		this.paymentsService.expectedPaymentsResolve({
			id: e.id, sf_account: r.sf_account, sf_id: r.sf_id, banktransid: e.banktransid
		}).subscribe(
			(res: any) => {
				if (res && res.success) {
					r._status = 'matched';
					r._posted = true;
					// Matching without clearing is how the matched-but-never-cleared pile
					// grows: the link says the deposit is accounted for while the rec still
					// shows the receipt outstanding. Every other match path clears — this
					// one didn't. 25 check receipts ($55.9k) were sitting in exactly that
					// state before this was added.
					this.sfClearBankTransIds([Number(e.banktransid)]);
					this.sfLogLoad(true);
					if (!done) { this.sfLoadErpRows(true); }
				} else {
					r._status = 'failed — ' + ((res && res.error) ? res.error : 'could not match');
				}
				if (done) { done(); }
			},
			() => { r._status = 'failed — could not match'; if (done) { done(); } }
		);
	}

	/**
	 * An `already_recorded` deposit whose receipt is provable: that receipt was posted
	 * from THIS bank line, so its GL narrative reads 'Bank rec: ' + the line's own
	 * description. The server only offers the link when the pairing is forced, so all
	 * this does is write the match link that was never written (or was deleted as bad)
	 * and clear the receipt. No receipt is created — posting again would double-count.
	 *
	 * Goes through simplefinSaveMatches with allow_shared FALSE so the server's
	 * one-claim-per-banktrans guard applies: if something else already claimed that
	 * receipt while the page was open, this reports a conflict instead of over-linking.
	 */
	sfArLinkReceipt(r: any, done?: () => void): void {
		const rl = r && r.receiptLink;
		if (!rl || !rl.banktransid) { if (done) { done(); } return; }
		r._status = 'matching…';
		this.paymentsService.simplefinSaveMatches({
			matches: [{
				sf_account: r.sf_account, sf_id: r.sf_id,
				transno: rl.transno, banktransid: rl.banktransid,
				method: 'manual', reason: 'GL narrative names this bank line (receipt #' + rl.transno + ')'
			}],
			allow_shared: false
		}).subscribe(
			(res: any) => {
				if (res && res.success) {
					r._status = 'matched';
					r._posted = true;
					this.sfClearBankTransIds([Number(rl.banktransid)]);
					if (!done) { this.sfLoadErpRows(true); }
				} else {
					r._status = 'failed — ' + ((res && res.error) ? res.error : 'could not match');
				}
				if (done) { done(); }
			},
			() => { r._status = 'failed — could not match'; if (done) { done(); } }
		);
	}

	/** Attention deposits whose receipt the GL narrative already names. */
	sfArReceiptLinkPending(): any[] {
		return (this.sfAr.attention || []).filter((r: any) => r.receiptLink && !r._posted);
	}

	/**
	 * Bulk-pair every deposit whose receipt is named by its own GL narrative. Same
	 * sequential driver as sfArResolveAllExpected — and safe for the same reason: the
	 * pairing is documented, not inferred, and nothing is posted.
	 */
	sfArLinkAllReceipts(): void {
		if (this.sfAr.resolving) { return; }
		const queue = this.sfArReceiptLinkPending();
		if (!queue.length) { return; }
		this.sfAr.resolving = true;
		this.sfAr.resolveTotal = queue.length;
		this.sfAr.resolveDone = 0;
		const next = (i: number) => {
			if (i >= queue.length) {
				this.sfAr.resolving = false;
				this.sf.message = 'Paired ' + this.sfAr.resolveDone + ' of ' + this.sfAr.resolveTotal
					+ ' deposit' + (this.sfAr.resolveTotal === 1 ? '' : 's') + ' to the receipt already posted from them.';
				this.sfLoadErpRows(true);
				this.loadSimplefinFeed();
				return;
			}
			this.sfArLinkReceipt(queue[i], () => {
				if (queue[i]._posted) { this.sfAr.resolveDone++; }
				next(i + 1);
			});
		};
		next(0);
	}

	/** Clear the loaded ERP rows for these banktransids, if they are in the window. */
	private sfClearBankTransIds(btids: number[]): void {
		const wanted = btids.filter((n: number) => n > 0);
		if (!wanted.length) { return; }
		const rows = (this.payments && this.payments.transactions) ? this.payments.transactions : [];
		const targets = rows.filter((t: any) => wanted.indexOf(this.bankTransId(t)) !== -1
			&& !t.clearedLocked && !t.isCleared);
		if (targets.length) { this.sfClearMatched(targets); }
	}

	/** Every check-log deposit in the attention tier still waiting to be paired. */
	sfArExpectedPending(): any[] {
		return (this.sfAr.attention || []).filter((r: any) => r.expectedResolve && !r._posted);
	}

	/**
	 * Bulk-pair every deposit whose receipt was already keyed from the check log.
	 *
	 * Same sequential driver as grpMatchAllExact/grpRunBulk — one at a time, counted,
	 * with a single ERP re-read at the end rather than one per row. Safe to bulk in a
	 * tier that must never be bulk-POSTED: no receipt is created here, each deposit is
	 * only tied to the receipt that already exists (and now cleared), so the failure
	 * mode of a wrong guess doesn't exist — the check log named the pairing.
	 */
	sfArResolveAllExpected(): void {
		if (this.sfAr.resolving) { return; }
		const queue = this.sfArExpectedPending();
		if (!queue.length) { return; }
		this.sfAr.resolving = true;
		this.sfAr.resolveTotal = queue.length;
		this.sfAr.resolveDone = 0;
		const next = (i: number) => {
			if (i >= queue.length) {
				this.sfAr.resolving = false;
				this.sf.message = 'Paired ' + this.sfAr.resolveDone + ' of ' + this.sfAr.resolveTotal
					+ ' check-log deposit' + (this.sfAr.resolveTotal === 1 ? '' : 's') + ' to their keyed receipts.';
				this.sfLoadErpRows(true);
				return;
			}
			this.sfArResolveExpected(queue[i], () => {
				if (queue[i]._posted) { this.sfAr.resolveDone++; }
				next(i + 1);
			});
		};
		next(0);
	}

	sfArSelCount(): number {
		return this.sfAr.ready.filter((r: any) => r._sel && !r._posted).length;
	}

	/**
	 * Rows the header select-all acts on: not already posted, and NOT amount-tie
	 * matches. An unconfirmed payer must be ticked deliberately, one row at a
	 * time — select-all used to sweep them in and defeat that guard.
	 */
	private sfArSelectable(): any[] {
		return this.sfAr.ready.filter((r: any) => !r._posted && !r.payer_unconfirmed);
	}

	/** How many ready rows select-all can act on (0 disables the header box). */
	sfArSelectableCount(): number {
		return this.sfArSelectable().length;
	}

	/**
	 * Every distinct customer this deposit could belong to, exact-amount ties
	 * first, each carrying the detail the expanded row shows: account, the tying
	 * invoice and the customer's open AR. A name on its own is not something an
	 * operator can check, so nothing here is offered without its numbers.
	 */
	sfArSugAll(r: any): any[] {
		const seen = new Set<string>();
		const out: any[] = [];
		const push = (c: any, exact: boolean) => {
			const name = String(c && c.name || '').trim();
			if (!name || seen.has(name)) { return; }
			seen.add(name);
			out.push({
				name, exact,
				debtorno: c.debtorno || '', branchcode: c.branchcode || '',
				transno: exact ? c.transno : null, order: exact ? c.order : null,
				out: exact ? c.out : null,
				openCount: c.openCount || 0, openTotal: c.openTotal || 0
			});
		};
		(r.suggestions || []).forEach((s: any) => push(s, true));
		(r.candidates || []).forEach((c: any) => push(c, false));
		return out;
	}

	/** Cached list while the panel is open — rebuilt objects each CD cycle would wipe expand state. */
	sfArSugList(r: any): any[] {
		if (!r._sugList) { r._sugList = this.sfArSugAll(r); }
		return r._sugList;
	}

	/** How many possible customers the expandable row would list. */
	sfArSugCount(r: any): number {
		return (r._sugList || this.sfArSugAll(r)).length;
	}

	sfArSugTogglePanel(r: any): void {
		r._sugOpen = !r._sugOpen;
		if (r._sugOpen) {
			r._sugList = this.sfArSugAll(r);
		} else {
			this.sfArSugClearAlloc(r);
			r._sugList = null;
		}
	}

	private sfArSugKey(s: any): string {
		return String(s.debtorno || '') + '|' + String(s.branchcode || '');
	}

	sfArSugIsOpen(r: any, s: any): boolean {
		return !!r._sugKey && r._sugKey === this.sfArSugKey(s);
	}

	private sfArSugClearAlloc(r: any): void {
		r._sugKey = null;
		r._plan = null;
		r._view = null;
		r._docs = null;
		r._pick = null;
		r._receipts = null;
		r.customer = null;
	}

	/**
	 * Expand a candidate's open documents under the unresolved row — same pick +
	 * post path as the partial-payment tier. Exact-amount suggestions pre-tick the
	 * tying invoice; name-only starts oldest-first so the operator can choose.
	 */
	sfArSugShowInvoices(r: any, s: any): void {
		if (r._posted || r._planLoading || this.sfAr.posting) { return; }
		const key = this.sfArSugKey(s);
		if (r._sugKey === key) {
			this.sfArSugClearAlloc(r);
			return;
		}
		if (!s.debtorno) { return; }
		r.customer = { debtorno: s.debtorno, branchcode: s.branchcode || '00', name: s.name };
		r._sugKey = key;
		r._plan = null;
		r._view = null;
		r._docs = null;
		r._pick = null;
		const seed = (s.exact && s.transno) ? Number(s.transno) : 0;
		// Full open-doc list first (a pinned plan returns only the pick). Then seed.
		r._planLoading = true;
		r._receipts = null;
		this.paymentsService.simplefinReceiptPlan({
			debtorno: r.customer.debtorno,
			branchcode: r.customer.branchcode,
			amount: this.round2(Number(r.amount)),
			posted: r.postedYmd || r.posted || '',
		}).subscribe(
			(plan: any) => {
				if (r._sugKey !== key) { return; }
				if (!plan || !plan.success) { r._planLoading = false; return; }
				r._docs = (plan.plan || []).slice();
				r._receipts = plan.unmatchedReceipts || [];
				if (seed) {
					r._pick = { transnos: [seed], creditTransnos: [] };
					this.sfArLoadPlan(r);
				} else {
					r._plan = plan;
					r._view = this.sfArBuildView(r, plan);
					r._planLoading = false;
				}
			},
			() => { if (r._sugKey === key) { r._planLoading = false; } }
		);
	}

	/**
	 * Pair this bank deposit to a receipt already in the ERP (keyed earlier, never
	 * tied to the feed). Does NOT post a second payment — that is the whole point
	 * when the deposit slip / check-log photo finally names the customer.
	 */
	sfArMatchExisting(r: any, rec: any): void {
		if (!r || !rec || r._posted || r._status === 'matching…' || this.sfAr.posting) { return; }
		const btid = Number(rec.banktransid);
		const transno = Number(rec.transno);
		if (!btid || !transno) { return; }
		r._status = 'matching…';
		const cust = r.customer;
		this.paymentsService.simplefinSaveMatches({
			matches: [{
				sf_account: r.sf_account, sf_id: r.sf_id,
				transno, banktransid: btid,
				method: 'manual',
				reason: 'Matched to existing receipt #' + transno
					+ (cust && cust.name ? (' · ' + cust.name) : ''),
			}],
			allow_shared: false
		}).subscribe(
			(res: any) => {
				if (res && res.success) {
					r._status = 'matched #' + transno;
					r._posted = true;
					this.sfClearBankTransIds([btid]);
					if (cust) {
						this.paymentsService.simplefinLearnAlias({
							description: String(r.description || ''),
							debtorno: cust.debtorno,
							branchcode: cust.branchcode,
							cust_name: cust.name || '',
						}).subscribe(() => { }, () => { });
					}
					this.sfLoadErpRows(true);
					this.loadSimplefinFeed();
					this.sfArRefreshAfterPost();
				} else {
					r._status = 'failed — ' + ((res && res.error) ? res.error : 'could not match');
				}
			},
			() => { r._status = 'failed — could not match'; }
		);
	}

	/**
	 * WHO the bank says paid. The server already parses this off the ACH line
	 * ("TYPE: … CO: XANDER LEG-Deposit XANDER LEGACY LL" → "XANDER LEGACY LL");
	 * it lands in this tier because the name did not resolve to a customer, NOT
	 * because there is no name. Showing the raw description instead of the parsed
	 * payer hid the one fact that makes the row postable.
	 */
	sfArPayerName(r: any): string {
		return String(r.payer || '').trim();
	}

	/**
	 * Search terms to try for an ACH payer, widest match last.
	 *
	 * The bank truncates the payer to ~16 characters — "XANDER LEGACY LLC" arrives
	 * as "XANDER LEGACY LL", "LEVEL UP NYC CORP" as "LEVEL UP NYC COR" — so an
	 * exact-name search can never succeed on the tail. What survives intact is the
	 * FRONT of the name, so drop trailing words one at a time:
	 *
	 *   LEVEL UP NYC COR → LEVEL UP NYC → LEVEL UP → LEVEL
	 *
	 * "LEVEL UP" is what finds "NYC Bud (Manhattan)(Level Up NY)", whose trade
	 * name is a parenthetical DBA. Truncation plus DBAs is why these deposits sit
	 * in the manual pile at all.
	 */
	sfArSearchLadder(term: string): string[] {
		const words = String(term || '').replace(/[^A-Za-z0-9 ]+/g, ' ')
			.replace(/\s+/g, ' ').trim().split(' ').filter((w: string) => w.length > 1);
		const out: string[] = [];
		for (let n = words.length; n >= 1; n--) {
			const t = words.slice(0, n).join(' ');
			if (t.length >= 3 && out.indexOf(t) === -1) { out.push(t); }
		}
		return out;
	}

	/**
	 * Row label: the payer when the bank gave one, else the deposit reference —
	 * "SB AmeriCU CU Mobile Rome NY-Deposit #731144" is identical on every mobile
	 * deposit, so only the number tells those apart.
	 */
	sfArDepositLabel(r: any): string {
		const payer = this.sfArPayerName(r);
		if (payer) { return payer; }
		const desc = (r.description || '').trim();
		const m = desc.match(/deposit\s*#?\s*(\d+)/i);
		return m ? ('Deposit #' + m[1]) : desc;
	}

	/** Deposit value of a tier — answers "how much cash is sitting here?". */
	sfArSum(rows: any[]): number {
		return (rows || []).reduce((t: number, r: any) => t + (Number(r.amount) || 0), 0);
	}

	/** Every unapplied deposit in the range, across all four tiers. */
	sfArUnappliedTotal(): number {
		return this.sfArSum(this.sfAr.ready) + this.sfArSum(this.sfAr.review)
			+ this.sfArSum(this.sfAr.attention) + this.sfArSum(this.sfAr.unresolved);
	}

	/** Only show a Status column once a post has actually written something to it. */
	sfArAnyStatus(rows: any[]): boolean {
		return (rows || []).some((r: any) => !!r._status);
	}

	/** True when the viewed range is one of the window buttons (else it reads "custom"). */
	sfArWindowIsPreset(): boolean {
		return this.sfImportWindows.some((d: number) => this.sfImportWindowActive(d));
	}

	/** Header checkbox state: all selectable rows checked. */
	sfArAllSelected(): boolean {
		const sel = this.sfArSelectable();
		return sel.length > 0 && sel.every((r: any) => r._sel);
	}

	/** Some but not all selected — drives the indeterminate dash. */
	sfArSomeSelected(): boolean {
		const sel = this.sfArSelectable();
		const n = sel.filter((r: any) => r._sel).length;
		return n > 0 && n < sel.length;
	}

	/** Header select-all / none. */
	sfArToggleAll(checked: boolean): void {
		if (this.sfAr.posting) { return; }
		this.sfArSelectable().forEach((r: any) => { r._sel = checked; });
	}

	/** Batch-post the checked ready rows, one at a time (plan → post → learn → next). */
	sfArBatchPost(): void {
		if (this.sfAr.posting) { return; }
		const queue = this.sfAr.ready.filter((r: any) => r._sel && !r._posted);
		if (!queue.length) { return; }
		this.sfAr.posting = true;
		this.sfAr.total = queue.length;
		this.sfAr.done = 0;
		this.sfAr.posted = 0;
		this.sfAr.failed = 0;
		const next = () => {
			const row = queue.shift();
			if (!row) {
				this.sfAr.posting = false;
				this.sf.message = 'Batch finished: ' + this.sfAr.posted + ' posted'
					+ (this.sfAr.failed ? ', ' + this.sfAr.failed + ' failed' : '') + '. Matching to bank lines…';
				this.sfAfterErpLoad = () => this.sfPairPostedRows();
				this.sfLoadErpRows(true);
				this.loadSimplefinFeed();
				this.sfArRefreshAfterPost();
				return;
			}
			this.sfArPostRow(row, () => { this.sfAr.done++; next(); });
		};
		next();
	}

	/**
	 * One deposit → customer receipt through the SAME payments/add flow the manual
	 * drawer uses. The server-built plan (oldest-first open invoices, or the exact
	 * tie's transnos) rides along as to[] — allocatefromto re-checks balances at
	 * post time, so a stale plan can never over-apply; leftover stays on account.
	 */
	private sfArPostRow(row: any, done: () => void): void {
		const cust = row.customer;
		if (!cust) { row._status = 'failed: no customer'; this.sfAr.failed++; done(); return; }
		row._status = 'posting…';
		const planReq: any = { debtorno: cust.debtorno, branchcode: cust.branchcode, amount: this.round2(Number(row.amount)) };
		if (this.sfArHasPick(row)) {
			// Documents the user ticked in the preview win over the engine's own tie.
			planReq.transnos = row._pick.transnos.slice();
			if (row._pick.creditTransnos.length) { planReq.credit_transnos = row._pick.creditTransnos.slice(); }
		} else if (row.tie && row.tie.transnos && row.tie.transnos.length) {
			planReq.transnos = row.tie.transnos;
			// Ties may net open credit notes (short-pay by credit memo) — apply them too.
			if (row.tie.creditTransnos && row.tie.creditTransnos.length) { planReq.credit_transnos = row.tie.creditTransnos; }
		}
		this.paymentsService.simplefinReceiptPlan(planReq).subscribe(
			(plan: any) => {
				if (!plan || !plan.success) { row._status = 'failed: no allocation plan'; this.sfAr.failed++; done(); return; }
				// Money already received at the bank — never a card method. Record the tender
				// the BANK reported, not "first non-card": that default followed sort_order
				// and stamped every one of these Cash (79 of 80 on MOOV, 24 of them ACH by
				// their own narrative, none actually cash), which made banktranstype useless
				// for reporting or for tender-based matching.
				const tender = this.sfTenderFromDescription(row.description);
				const payment = {
					debtorno: cust.debtorno,
					branchcode: cust.branchcode,
					payment_type: this.sfPaymentTypeFor(tender),
					bankaccount: String(row.erp_bankact || this.selectedBankAccount.value || ''),
					datepaid: row.postedYmd || row.posted,
					checkno: tender === 'check' ? this.sfDepositSlipNo(row.description) : '',
					reference: String(row.description || row.sf_id || '').slice(0, 50),
					description: 'Bank rec: ' + String(row.description || row.sf_id || ''),
					amount: this.round2(Number(row.amount)),
					discount: 0,
					currency: plan.currcode || 'USD',
					journalno: '1',
				};
				this.paymentsService.addCashRecPayment({ payment, charge_card: false, to: plan.to || [] }).subscribe(
					(res: any) => {
						if (res && res.success) {
							row._posted = true;
							const transno = res.payment && res.payment.transno ? res.payment.transno : '';
							// Record WHICH receipt this deposit produced, the same way the GL-journal
							// path does. Without it the only tie back was an amount guess.
							this.sfLinkPostedReceipt(row, transno);
							row._status = 'posted' + (transno ? ' #' + transno : '')
								+ (Number(plan.onAccount) > 0 ? ' · ' + Number(plan.onAccount).toFixed(2) + ' on account' : '');
							this.sfAr.posted++;
							this.sfPendingPairRows.push(row);
							// Remember this payer so next import resolves it instantly.
							this.paymentsService.simplefinLearnAlias({
								description: String(row.description || ''),
								debtorno: cust.debtorno,
								branchcode: cust.branchcode,
								cust_name: cust.name || '',
							}).subscribe(() => { }, () => { });
						} else {
							row._status = 'failed: ' + ((res && res.message) || 'post error');
							this.sfAr.failed++;
						}
						done();
					},
					() => { row._status = 'failed (request error)'; this.sfAr.failed++; done(); }
				);
			},
			() => { row._status = 'failed: plan error'; this.sfAr.failed++; done(); }
		);
	}

	/** Amber row: one click posts with oldest-first allocation across open invoices. */
	sfArPostReview(row: any): void {
		if (row._posted || row._status === 'posting…' || this.sfAr.posting) { return; }
		this.sfArPostRow(row, () => {
			this.sfAfterErpLoad = () => this.sfPairPostedRows();
			this.sfLoadErpRows(true);
			this.loadSimplefinFeed();
			this.sfArRefreshAfterPost();
		});
	}

	/** Toggle the allocation preview on an amber row (no posting). */
	sfArPreview(row: any): void {
		if (row._plan) {
			row._plan = null; row._view = null; row._docs = null; row._pick = null; row._receipts = null;
			return;
		}
		if (!row.customer || row._planLoading) { return; }
		this.sfArLoadPlan(row);
	}

	/** Ready rows are exact proposals; reveal their source facts without changing allocation. */
	sfArToggleReadyDetails(row: any): void {
		row._detailsOpen = !row._detailsOpen;
	}

	/**
	 * (Re)build the preview. With no pick the server allocates oldest-first; once the
	 * user ticks documents we send them as transnos/credit_transnos and the SAME server
	 * plan builder does the arithmetic — the preview can never disagree with what posts.
	 * Also loads unmatched keyed receipts so the operator can Match instead of posting twice.
	 */
	private sfArLoadPlan(row: any): void {
		const cust = row.customer;
		if (!cust) { return; }
		row._planLoading = true;
		const req: any = {
			debtorno: cust.debtorno, branchcode: cust.branchcode, amount: this.round2(Number(row.amount)),
			posted: row.postedYmd || row.posted || '',
		};
		if (this.sfArHasPick(row)) {
			req.transnos = row._pick.transnos.slice();
			if (row._pick.creditTransnos.length) { req.credit_transnos = row._pick.creditTransnos.slice(); }
		}
		this.paymentsService.simplefinReceiptPlan(req).subscribe(
			(plan: any) => {
				row._planLoading = false;
				if (!plan || !plan.success) { return; }
				row._plan = plan;
				// Keep the first full receipt list — a pinned re-plan still returns them, but
				// don't wipe a list the operator is staring at if a later call omits it.
				if (plan.unmatchedReceipts) { row._receipts = plan.unmatchedReceipts; }
				// An explicit pick makes the server return ONLY the picked documents, so the
				// full open-document list is captured from the unpinned plan and kept as the
				// thing we render. Otherwise ticking one invoice would erase the other rows
				// and leave no way to tick a second.
				if (!this.sfArHasPick(row)) { row._docs = (plan.plan || []).slice(); }
				row._view = this.sfArBuildView(row, plan);
			},
			() => { row._planLoading = false; }
		);
	}

	/** A transno can carry two debtortrans rows here, so the balance is part of the key. */
	private sfArDocKey(p: any): string {
		return p.kind + '|' + p.transno + '|' + p.outstanding;
	}

	/** Every open document, carrying the applied/left-open figures of the current plan. */
	private sfArBuildView(row: any, plan: any): any[] {
		const inPlan: { [k: string]: any } = {};
		(plan.plan || []).forEach((p: any) => { inPlan[this.sfArDocKey(p)] = p; });
		return (row._docs || []).map((d: any) => {
			const hit = inPlan[this.sfArDocKey(d)];
			return {
				kind: d.kind, transno: d.transno, trandate: d.trandate, outstanding: d.outstanding,
				applied: hit ? hit.applied : 0,
				leftOpen: hit ? hit.leftOpen : d.outstanding,
			};
		});
	}

	/** True once the user has chosen documents by hand (empty pick ⇒ oldest-first). */
	sfArHasPick(row: any): boolean {
		return !!(row._pick && row._pick.transnos && row._pick.transnos.length);
	}

	sfArPickedCount(row: any): number {
		return this.sfArHasPick(row)
			? row._pick.transnos.length + (row._pick.creditTransnos ? row._pick.creditTransnos.length : 0)
			: 0;
	}

	/** Is this preview line one of the picked documents? */
	sfArIsPicked(row: any, p: any): boolean {
		if (!row._pick) { return false; }
		const list = p.kind === 'credit' ? row._pick.creditTransnos : row._pick.transnos;
		return !!list && list.indexOf(Number(p.transno)) !== -1;
	}

	/**
	 * Tick/untick a document, then re-plan. Selection is by TRANSNO because that is
	 * what the server plan builder filters on — a transno carrying two debtortrans
	 * rows (split invoices share one number here) selects both, which is why the
	 * checkbox is bound per transno rather than per preview line.
	 */
	sfArTogglePick(row: any, p: any): void {
		if (row._planLoading || row._posted) { return; }
		if (!row._pick) { row._pick = { transnos: [], creditTransnos: [] }; }
		const key = p.kind === 'credit' ? 'creditTransnos' : 'transnos';
		const list: number[] = row._pick[key];
		const tn = Number(p.transno);
		const at = list.indexOf(tn);
		if (at === -1) { list.push(tn); } else { list.splice(at, 1); }
		// The server keys credit filtering off transnos, so a credit-only pick cannot be
		// expressed — it stays ticked (the intent is kept) but the plan runs oldest-first
		// until an invoice is chosen too. Clearing both lists returns to auto outright.
		if (!row._pick.transnos.length && !row._pick.creditTransnos.length) { row._pick = null; }
		this.sfArLoadPlan(row);
	}

	/** Back to the automatic oldest-first plan. */
	sfArPickReset(row: any): void {
		if (row._planLoading || row._posted || !row._pick) { return; }
		row._pick = null;
		this.sfArLoadPlan(row);
	}

	/** Credits ticked with no invoice yet — the pick has no effect until one is chosen. */
	sfArCreditOnlyPick(row: any): boolean {
		return !!(row._pick && !row._pick.transnos.length && row._pick.creditTransnos.length);
	}

	/** Unresolved row: hand off to the receipt drawer, optionally seeding a suggested customer. */
	sfArOpenDrawer(row: any, suggestName?: string): void {
		this.sfOpenReceipt(row);
		if (suggestName) {
			this.sfReceiptSearch = suggestName;
			this.sfSearchReceiptCustomers();
		}
	}

	/* ---------- bank fees / interest: two-line GL journal from a feed row ---------- */

	sfOpenJournal(s: any): void {
		const code = String(this.selectedBankAccount.value || s.erp_bankact || '');
		if (!code) { this.sf.message = 'Select a bank account first.'; return; }
		this.dialog.open(SlimJournalEntryDialogComponent, {
			width: '720px',
			maxWidth: '96vw',
			maxHeight: '90vh',
			autoFocus: false,
			restoreFocus: true,
			data: {
				useBankOffsetJournal: true,
				preferredBankAccountCode: code,
				postingDate: s.postedYmd || s.posted,
				presetAmount: Math.abs(this.round2(Number(s.amount))),
				presetDescription: String(s.description || ''),
				// Fee (money out) credits the bank; interest (money in) debits it.
				presetBankDirection: Number(s.amount) < 0 ? 'credit_bank' : 'debit_bank',
			} as SlimJournalEntryDialogData,
		}).afterClosed().subscribe((r) => {
			if (r?.posted) {
				this.paymentsService.simplefinSetPosted({
					sf_account: s.sf_account,
					sf_id: s.sf_id,
					post_type: 0,
					post_transno: Number(r.transno),
					post_kind: 'journal',
				}).subscribe((saved: any) => {
					if (!saved?.success) {
						this.sf.message = 'Journal posted, but its bank-feed reference was not saved.';
						return;
					}
					s.feedPosted = true;
					s.feedPostType = 0;
					s.feedPostTransno = Number(r.transno);
					s.feedPostKind = 'journal';
					s.ignored = false;
					this.sf.message = `Journal ${r.transno} posted and linked to the bank line.`;
					this.refreshGlBookBalance();
					this.applyFilters();
				});
			}
		});
	}

	private sfPostingSuggestedName(description: any): string {
		const raw = String(description || '');
		const co = /\bCO:\s*([^\-]+)/i.exec(raw);
		return (co ? co[1] : raw).replace(/\b(TYPE|ACH|PAYMENT|WITHDRAWAL|DEPOSIT)\b/gi, '').trim();
	}

	sfSearchVendors(): void {
		this.sfVendorLoading = true;
		this.vendorService.getVendorSearch(this.sfVendorSearch).subscribe({
			next: (result: any) => {
				const rows = Array.isArray(result) ? result : (result?.rows || result?.vendors || result?.suppliers || []);
				this.sfVendorResults = Array.isArray(rows) ? rows.slice(0, 20) : [];
				this.sfVendorLoading = false;
			},
			error: () => { this.sfVendorResults = []; this.sfVendorLoading = false; },
		});
	}

	sfSelectPostingVendor(row: any, nextMode: 'invoice' | 'payment' = 'payment'): void {
		const id = String(row?.supplierid || '');
		if (!id) { return; }
		this.sfVendorLoading = true;
		this.vendorService.getVendor(id).subscribe({
			next: (vendor: any) => { this.sfPostingVendor = vendor; this.sfPostingMode = nextMode; this.sfVendorLoading = false; },
			error: () => { this.sfVendorLoading = false; this.sf.message = 'Could not load that vendor.'; },
		});
	}

	sfVendorCreated(supplierid: string): void {
		// A brand-new vendor cannot have an existing invoice to allocate. Create
		// the invoice first, then the invoice event opens payment/allocation.
		this.sfSelectPostingVendor({ supplierid }, 'invoice');
	}

	sfPostingCompleted(): void {
		const postedBankRow = this.sfPostingRow;
		this.sf.message = 'Posted to ERP. Reloading bank and ERP transactions.';
		this.sfClosePosting();
		this.loadSimplefinFeed();
		// Vendor payments create a banktrans row. After the ERP reload, pair the
		// originating feed row to the newest exact signed amount so the operator
		// does not have to find and match the transaction a second time.
		if (postedBankRow && !postedBankRow.matched && !postedBankRow.ignored) {
			this.sfPendingPairRow = postedBankRow;
			this.sfAfterErpLoad = () => this.sfPairPostedRow();
		}
		this.sfLoadErpRows(true);
		this.loadTransactions();
	}

	/** banktransid -> matched feed row(s); drives the ERP pane's badges and links. */
	private sfRebuildMatchIdx(): void {
		const idx: { [id: number]: any } = {};
		for (const s of (this.sf.transactions || [])) {
			for (const m of (s.matchList || [])) {
				const btid = Number(m.banktransid);
				if (btid > 0 && !idx[btid]) { idx[btid] = s; }
			}
		}
		this.sfMatchIdx = idx;
	}

	sfErpMatch(t: any): any {
		return this.sfMatchIdx[this.bankTransId(t)] || null;
	}

	/* ---------- group matching: pick 2/3/4 bank lines ↔ ERP postings ---------- */

	sfIsBankSel(s: any): boolean {
		return this.sfSelBank.indexOf(s) !== -1;
	}

	sfToggleBankSel(s: any): void {
		if (s.matched || s.ignored || s.feedPosted) { return; }
		const i = this.sfSelBank.indexOf(s);
		if (i === -1) { this.sfSelBank = this.sfSelBank.concat([s]); } else { this.sfSelBank = this.sfSelBank.filter((x: any) => x !== s); }
		// Removing the last group member from inside the match modal leaves it empty.
		if (!this.sfSelBank.length && !this.sfSelectedBank && this.sfMatchModalRef) { this.sfCloseMatch(); }
	}

	sfClearBankSel(): void {
		this.sfSelBank = [];
	}

	/** Open the match modal for the multi-selected bank lines (matched as one sum). */
	sfOpenGroupMatch(): void {
		if (!this.sfSelBank.length || !this.sfMatchModal) { return; }
		this.sfSelectedBank = null;
		this.sfSelErp = [];
		this.sfCandidateSearch = '';
		this.sfCandidateKind = 'all';
		this.sfCandidateDays = 0;
		this.sfCandidateSort = 'recommended';
		this.sfMatchExpanded = false;
		if (this.sfMatchModalRef) { this.sfMatchModalRef.close(); }
		const ref = this.modalService.open(this.sfMatchModal, {
			size: 'xl',
			scrollable: true,
			centered: true,
			windowClass: 'sf-match-modal-window',
		});
		this.sfMatchModalRef = ref;
		ref.result.then(
			() => { if (this.sfMatchModalRef === ref) { this.sfMatchModalRef = undefined; this.sfSelErp = []; } },
			() => { if (this.sfMatchModalRef === ref) { this.sfMatchModalRef = undefined; this.sfSelErp = []; } },
		);
	}

	sfSelBankSum(): number {
		return this.round2(this.sfSelBank.reduce((sum: number, s: any) => sum + (Number(s.amount) || 0), 0));
	}

	/** The bank side of the match modal: the multi-selection, or the single clicked row. */
	sfMatchGroup(): any[] {
		if (this.sfSelBank.length) { return this.sfSelBank; }
		return this.sfSelectedBank ? [this.sfSelectedBank] : [];
	}

	sfMatchGroupSum(): number {
		return this.round2(this.sfMatchGroup().reduce((sum: number, s: any) => sum + (Number(s.amount) || 0), 0));
	}

	sfIsErpSel(t: any): boolean {
		return this.sfSelErp.indexOf(t) !== -1;
	}

	sfToggleErpSel(t: any): void {
		if (this.sfErpMatch(t) || t.clearedLocked || !(this.bankTransId(t) > 0)) { return; }
		const i = this.sfSelErp.indexOf(t);
		if (i === -1) { this.sfSelErp = this.sfSelErp.concat([t]); } else { this.sfSelErp = this.sfSelErp.filter((x: any) => x !== t); }
	}

	sfSelErpSum(): number {
		return this.round2(this.sfSelErp.reduce((sum: number, t: any) => sum + (parseFloat(t.amount) || 0), 0));
	}

	/** Remaining difference between the bank group and the ERP selection. */
	sfComboDiff(): number {
		return this.round2(this.sfMatchGroupSum() - this.sfSelErpSum());
	}

	sfCanCompleteCombo(): boolean {
		return this.sfMatchGroup().length > 0 && this.sfSelErp.length > 0 && Math.abs(this.sfComboDiff()) < 0.005;
	}

	sfCanAcceptComboVariance(): boolean {
		const bank = this.sfMatchGroupSum();
		const erp = this.sfSelErpSum();
		return this.sfMatchGroup().length > 0 && this.sfSelErp.length > 0 &&
			Math.sign(bank) === Math.sign(erp) && Math.abs(this.sfComboDiff()) >= 0.005;
	}

	/** Complete the group match: every selected bank line ↔ every selected ERP posting. */
	sfCompleteCombo(): void {
		if (!this.sfCanCompleteCombo()) { return; }
		this.sfCompleteMatch(this.sfMatchGroup().slice(), this.sfSelErp.slice());
	}

	sfCompleteComboWithVariance(): void {
		if (!this.sfCanAcceptComboVariance()) { return; }
		this.sfCompleteMatch(this.sfMatchGroup().slice(), this.sfSelErp.slice(), true);
	}

	private sfCompleteMatch(bankRows: any[], erpRows: any[], acceptVariance = false): void {
		if (!bankRows.length || !erpRows.length) { return; }
		const total = this.round2(bankRows.reduce((sum: number, s: any) => sum + (Number(s.amount) || 0), 0));
		const erpTotal = this.round2(erpRows.reduce((sum: number, t: any) => sum + (Number(t.amount) || 0), 0));
		const difference = this.round2(total - erpTotal);
		const baseLabel = bankRows.length > 1 || erpRows.length > 1
			? 'Group match: ' + bankRows.length + ' bank line(s) ↔ ' + erpRows.length + ' ERP posting(s)'
			: 'Manually matched';
		const label = acceptVariance
			? `${baseLabel}; accepted bank/ERP variance ${difference.toFixed(2)}`
			: baseLabel;
		for (const s of bankRows) {
			s.matchReason = label;
			for (const t of erpRows) { this.sfApplyRowMatch(s, t, false, label); }
		}
		this.sfRebuildMatchIdx();
		// Sharing a banktransid is only correct for a genuine group — SEVERAL bank lines
		// settling one ERP posting, where the amounts sum to it. On a 1:1 match it is a
		// double-claim, and passing allow_shared unconditionally switched off the server's
		// "an ERP bank transaction can only be matched once" guard: six different customers'
		// $324 deposits ended up on one $324 receipt (7/29 batch), consuming deposits that
		// still owed their own receipts. Same test grpPostGroup() uses.
		this.sfPersistMatches(bankRows, 'manual', bankRows.length > 1);
		this.sfCloseMatch();
		this.sfClearBankSel();
		this.sf.message = label + ' — $' + total.toFixed(2) + '.';
		this.sfClearMatched(erpRows);
	}

	/** Template-visible banktransid (bankTransId itself is private). */
	sfBtid(t: any): number {
		return this.bankTransId(t);
	}

	/** Bank pane rows: account-scoped feed, then status filter + search. */
	sfBankRows(): any[] {
		const account = String(this.selectedBankAccount.value || '');
		const q = (this.sfBankSearch || '').toLowerCase().trim();
		const rows = (this.sf.transactions || []).filter((s: any) => {
			if (account && String(s.erp_bankact) !== account) { return false; }
			if (s.matched && this.sfRevealLink === Number(s.matchBankTransId)) { return true; }
			if (this.sfStatusFilter === 'matched' && !s.matched && !s.feedPosted) { return false; }
			if (this.sfStatusFilter === 'unmatched' && (s.matched || s.ignored || s.feedPosted)) { return false; }
			if (this.sfStatusFilter === 'ignored' && !s.ignored) { return false; }
			if (!this.sfWithinSubset(s.postedYmd || s.posted)) { return false; }
			if (!this.sfDirectionMatches(Number(s.amount))) { return false; }
			if (q && String(s.description).toLowerCase().indexOf(q) === -1 && String(s.amount).indexOf(q) === -1) { return false; }
			return true;
		});
		return this.sfSortSubset(this.sfOccurrenceSubset(rows), 'bank');
	}

	/** ERP pane rows: the loaded rec ledger, status filter + search. */
	sfErpRows(): any[] {
		const q = (this.sfErpSearch || '').toLowerCase().trim();
		const rows = (this.payments && this.payments.transactions) ? this.payments.transactions : [];
		const filtered = rows.filter((t: any) => {
			const matched = !!this.sfErpMatch(t);
			if (matched && this.sfRevealLink === this.bankTransId(t)) { return true; }
			if (this.sfStatusFilter === 'unmatched' && this.sfIsInternalReversal(t)) { return false; }
			// 'ignored' only exists on the bank side — treat it as 'all' here.
			if (this.sfStatusFilter === 'matched' && !matched) { return false; }
			if (this.sfStatusFilter === 'unmatched' && matched) { return false; }
			if (!this.sfWithinSubset(t.trandateYmd || t.trandate)) { return false; }
			if (!this.sfDirectionMatches(Number(t.amount))) { return false; }
			if (q) {
				const hay = (String(t.name || '') + ' ' + String(t.reference || '') + ' ' + String(t.type || '') + ' ' + String(t.amount || '')).toLowerCase();
				if (hay.indexOf(q) === -1) { return false; }
			}
			return true;
		});
		return this.sfSortSubset(this.sfOccurrenceSubset(filtered), 'erp');
	}

	private sfWithinSubset(value: any): boolean {
		const ms = this.sfDateMs(value);
		if (this.sfSubsetFrom && ms < this.sfDateMs(this.sfSubsetFrom)) { return false; }
		if (this.sfSubsetTo && ms > this.sfDateMs(this.sfSubsetTo)) { return false; }
		return true;
	}

	private sfDirectionMatches(amount: number): boolean {
		return this.sfDirection === 'all' || (this.sfDirection === 'in' ? amount > 0 : amount < 0);
	}

	private sfOccurrenceSubset(rows: any[]): any[] {
		if (this.sfAmountOccurrence === 'all') { return rows; }
		const counts: { [amount: string]: number } = {};
		rows.forEach((row: any) => {
			const key = this.round2(Number(row.amount)).toFixed(2);
			counts[key] = (counts[key] || 0) + 1;
		});
		return rows.filter((row: any) => {
			const count = counts[this.round2(Number(row.amount)).toFixed(2)] || 0;
			return this.sfAmountOccurrence === 'single' ? count === 1 : count > 1;
		});
	}

	private sfSortSubset(rows: any[], side: 'bank' | 'erp'): any[] {
		const dateOf = (row: any) => this.sfDateMs(side === 'bank' ? (row.postedYmd || row.posted) : (row.trandateYmd || row.trandate));
		return rows.slice().sort((a: any, b: any) => {
			if (this.sfSort === 'date-asc') { return dateOf(a) - dateOf(b); }
			if (this.sfSort === 'date-desc') { return dateOf(b) - dateOf(a); }
			if (this.sfSort === 'amount-asc') { return Number(a.amount) - Number(b.amount); }
			if (this.sfSort === 'amount-desc') { return Number(b.amount) - Number(a.amount); }
			const an = String(side === 'bank' ? a.description : a.name || '').toLowerCase();
			const bn = String(side === 'bank' ? b.description : b.name || '').toLowerCase();
			return an.localeCompare(bn);
		});
	}

	sfResetSubset(): void {
		this.sfSubsetFrom = '';
		this.sfSubsetTo = '';
		this.sfAmountOccurrence = 'all';
		this.sfDirection = 'all';
		this.sfSort = 'date-desc';
	}

	sfRowsTotal(rows: any[]): number {
		return rows.reduce((total: number, row: any) => this.round2(total + (Number(row.amount) || 0)), 0);
	}

	/** Bank-side truth for the account+range (filter/search agnostic, ignores ignored). */
	sfBankStats(): { count: number; total: number; received: number; receivedCount: number; paidOut: number; paidOutCount: number; matchedCount: number; matchedTotal: number; openCount: number; openTotal: number } {
		const account = String(this.selectedBankAccount.value || '');
		const out = { count: 0, total: 0, received: 0, receivedCount: 0, paidOut: 0, paidOutCount: 0, matchedCount: 0, matchedTotal: 0, openCount: 0, openTotal: 0 };
		for (const s of (this.sf.transactions || [])) {
			if (s.ignored) { continue; }
			if (account && String(s.erp_bankact) !== account) { continue; }
			if (!this.sfWithinSubset(s.postedYmd || s.posted)) { continue; }
			const amt = this.round2(Number(s.amount));
			if (!Number.isFinite(amt)) { continue; }
			out.count++;
			out.total = this.round2(out.total + amt);
			if (amt > 0) { out.receivedCount++; out.received = this.round2(out.received + amt); } else { out.paidOutCount++; out.paidOut = this.round2(out.paidOut + amt); }
			if (s.matched || s.feedPosted) { out.matchedCount++; out.matchedTotal = this.round2(out.matchedTotal + amt); }
			else { out.openCount++; out.openTotal = this.round2(out.openTotal + amt); }
		}
		return out;
	}

	/** ERP-side truth for the loaded ledger rows. */
	sfErpStats(): { count: number; total: number; received: number; receivedCount: number; paidOut: number; paidOutCount: number; matchedCount: number; matchedTotal: number; openCount: number; openTotal: number } {
		const out = { count: 0, total: 0, received: 0, receivedCount: 0, paidOut: 0, paidOutCount: 0, matchedCount: 0, matchedTotal: 0, openCount: 0, openTotal: 0 };
		const rows = (this.payments && this.payments.transactions) ? this.payments.transactions : [];
		for (const t of rows) {
			if (this.sfIsInternalReversal(t)) { continue; }
			if (!this.sfWithinSubset(t.trandateYmd || t.trandate)) { continue; }
			const amt = this.round2(parseFloat(t.amount));
			if (!Number.isFinite(amt)) { continue; }
			out.count++;
			out.total = this.round2(out.total + amt);
			if (amt > 0) { out.receivedCount++; out.received = this.round2(out.received + amt); }
			else { out.paidOutCount++; out.paidOut = this.round2(out.paidOut + amt); }
			if (this.sfErpMatch(t)) { out.matchedCount++; out.matchedTotal = this.round2(out.matchedTotal + amt); }
			else { out.openCount++; out.openTotal = this.round2(out.openTotal + amt); }
		}
		return out;
	}

	sfApplySummaryFilter(kind: 'received' | 'paid' | 'matched' | 'unmatched'): void {
		if (this.sfSummaryFilterActive(kind)) {
			this.sfStatusFilter = 'all';
			this.sfDirection = 'all';
			return;
		}
		this.sfDirection = kind === 'received' ? 'in' : (kind === 'paid' ? 'out' : 'all');
		this.sfStatusFilter = kind === 'matched' ? 'matched' : (kind === 'unmatched' ? 'unmatched' : 'all');
	}

	sfSummaryFilterActive(kind: 'received' | 'paid' | 'matched' | 'unmatched'): boolean {
		if (kind === 'received') { return this.sfDirection === 'in' && this.sfStatusFilter === 'all'; }
		if (kind === 'paid') { return this.sfDirection === 'out' && this.sfStatusFilter === 'all'; }
		if (kind === 'matched') { return this.sfDirection === 'all' && this.sfStatusFilter === 'matched'; }
		return this.sfDirection === 'all' && this.sfStatusFilter === 'unmatched';
	}

	sfRecDiff(): number {
		return this.round2(this.sfBankStats().total - this.sfErpStats().total);
	}

	/** Load the ERP side with the FULL ledger (AR receipts + AP payouts). */
	sfLoadErpRows(silent = false): void {
		if (!this.selectedBankAccount.value) { this.sf.message = 'Select a bank account on the Reconciliation tab first.'; return; }
		// Matching needs both ledgers. Move the picker too, or it shows a selection
		// that no longer describes what is loaded.
		if (this.arapMode.value !== 'both') {
			this.arapMode.setValue('both');
			// emitEvent:false — this method is already doing its own load; letting the
			// picker's valueChanges fire would kick off a second, competing one.
			this.arapLedgers.setValue(['ar', 'ap'], { emitEvent: false });
		}
		this.sfErpLoading = true;
		const data = {
			from: this.datefrom.value,
			to: this.dateto.value,
			locations: [],
			arap_mode: 'both',
			showCleared: true,
			payment_type: [],
			bankAccount: this.selectedBankAccount.value,
		};
		this.paymentsService.getBankRec(data).subscribe({
			next: (results: any) => {
				this.sfErpLoading = false;
				this.payments = results || { transactions: [] };
				this.sfRebuildInternalReversals();
				this.applyGlBookFromApi(results);
				this.applyFilters();
				if (!silent && !(results?.transactions || []).length) {
					this.sf.message = 'No ERP bank transactions exist for this account and date range.';
				}
				if (this.sfAfterErpLoad) {
					const cb = this.sfAfterErpLoad;
					this.sfAfterErpLoad = null;
					cb();
				}
			},
			error: () => {
				this.sfErpLoading = false;
				this.sfAfterErpLoad = null;
				this.sf.message = 'Loading the ERP ledger failed.';
			},
		});
	}

	openSfCustomerAccount(t: any): void {
		const debtorno = String(t?.debtorno || '').trim();
		const branchcode = String(t?.branchcode || '').trim();
		if (!debtorno || !branchcode || String(t?.type) !== '12') { return; }
		const ref = this.modalService.open(CustomerAccountOverviewModalComponent, {
			size: 'xl',
			scrollable: true,
			windowClass: 'ca-overview-modal-window',
		});
		ref.componentInstance.debtorno = debtorno;
		ref.componentInstance.branchcode = branchcode;
		ref.componentInstance.customerTitle = String(t?.name || `${debtorno}.${branchcode}`);
	}

	/** Click a bank row: matched → jump to its ERP partner; unmatched → arm pairing. */
	sfBankRowClick(s: any): void {
		if (s.ignored) { return; }
		if (s.matched) { this.sfJump('erp', s.matchBankTransId); return; }
		// Group mode: while a multi-selection is active, plain row clicks keep
		// building the group instead of opening the single-row modal.
		if (this.sfSelBank.length) { this.sfToggleBankSel(s); return; }
		if (this.sfSelectedBank === s && this.sfMatchModalRef) { this.sfCloseMatch(); return; }
		this.sfSelectedBank = s;
		this.sfCandidateSearch = '';
		this.sfCandidateKind = 'all';
		this.sfCandidateDays = 0;
		this.sfCandidateSort = 'recommended';
		this.sfMatchExpanded = false;
		if (!this.sfMatchModal) { return; }
		if (this.sfMatchModalRef) { this.sfMatchModalRef.close(); }
		const ref = this.modalService.open(this.sfMatchModal, {
			size: 'xl',
			scrollable: true,
			centered: true,
			windowClass: 'sf-match-modal-window',
		});
		this.sfMatchModalRef = ref;
		ref.result.then(
			() => { if (this.sfMatchModalRef === ref) { this.sfMatchModalRef = undefined; this.sfSelectedBank = null; } },
			() => { if (this.sfMatchModalRef === ref) { this.sfMatchModalRef = undefined; this.sfSelectedBank = null; } },
		);
	}

	/** Click an ERP row: matched → jump to its bank partner; else pair with the armed bank side. */
	sfErpRowClick(t: any): void {
		if (this.sfErpMatch(t)) { this.sfJump('bank', this.bankTransId(t)); return; }
		if (t.clearedLocked || !(this.bankTransId(t) > 0)) { return; }
		// Group selection armed: this ERP posting settles ALL selected bank lines —
		// only when the sums tie to the cent.
		if (this.sfSelBank.length) {
			const diff = this.round2(this.sfSelBankSum() - this.round2(parseFloat(t.amount)));
			if (Math.abs(diff) < 0.005) {
				this.sfCompleteMatch(this.sfSelBank.slice(), [t]);
			} else {
				this.sf.message = 'Selected bank lines total $' + this.sfSelBankSum().toFixed(2) + ' — off by $' + diff.toFixed(2) + ' from this posting. Add or remove bank lines until the sums tie.';
			}
			return;
		}
		if (this.sfSelectedBank) {
			this.sfPairWith(this.sfSelectedBank, t);
		}
	}

	/** ERP rows equal to the armed bank amount (single or group sum) glow. */
	sfIsSuggested(t: any): boolean {
		if (this.sfErpMatch(t)) { return false; }
		const target = this.sfSelBank.length ? this.sfSelBankSum() : (this.sfSelectedBank ? this.round2(Number(this.sfSelectedBank.amount)) : null);
		if (target === null) { return false; }
		return this.round2(parseFloat(t.amount)) === target;
	}

	/**
	 * Ranked, still-available ERP possibilities for the armed bank side (single
	 * row or group — amounts compare against the group SUM). While combining
	 * (ERP checkboxes ticked, or Evidence = "Show all"), the amount/name evidence
	 * filter relaxes so partial-amount postings can be picked.
	 */
	sfPossibleMatches(): Array<{ row: any; exactAmount: boolean; daysApart: number; nameScore: number }> {
		const group = this.sfMatchGroup();
		if (!group.length) { return []; }
		const s = group[0];
		const bankAmount = this.sfMatchGroupSum();
		const bankDate = this.sfDateMs(s.postedYmd || s.posted);
		const q = this.sfCandidateSearch.toLowerCase().trim();
		const combining = this.sfSelErp.length > 0 || this.sfCandidateKind === 'any';
		const candidates = this.sfClearableRecRows()
			.filter((t: any) => !this.sfErpMatch(t))
			.map((t: any) => {
				const exactAmount = this.round2(Number(t.amount)) === bankAmount;
				const nameScore = this.sfNameScore(s.description, t.name);
				const erpDate = this.sfDateMs(t.trandateYmd || t.trandate);
				const daysApart = bankDate && erpDate ? Math.round(Math.abs(bankDate - erpDate) / 86400000) : 9999;
				return { row: t, exactAmount, daysApart, nameScore };
			})
			.filter((c: any) => combining || c.exactAmount || c.nameScore > 0)
			.filter((c: any) => combining || this.sfCandidateKind === 'all' || (this.sfCandidateKind === 'exact' ? c.exactAmount : c.nameScore > 0))
			.filter((c: any) => !this.sfCandidateDays || c.daysApart <= this.sfCandidateDays)
			.filter((c: any) => {
				if (!q) { return true; }
				const t = c.row;
				return [t.name, t.debtorno, t.supplierno, t.reference, t.typename, t.type, t.amount, t.trandate]
					.some((value: any) => String(value || '').toLowerCase().indexOf(q) !== -1);
			});
		candidates.sort((a: any, b: any) => {
			if (this.sfCandidateSort === 'closest') { return a.daysApart - b.daysApart; }
			if (this.sfCandidateSort === 'amount') { return Math.abs(Number(a.row.amount) - bankAmount) - Math.abs(Number(b.row.amount) - bankAmount); }
			if (this.sfCandidateSort === 'name') { return String(a.row.name || '').localeCompare(String(b.row.name || '')); }
			return Number(b.exactAmount) - Number(a.exactAmount) || b.nameScore - a.nameScore || a.daysApart - b.daysApart;
		});
		return candidates.slice(0, 100);
	}

	/** A user may explicitly accept a same-direction bank/ERP variance. */
	sfMatchCandidate(candidate: { row: any; exactAmount: boolean }): void {
		const group = this.sfMatchGroup();
		if (!group.length || !candidate?.row) { return; }
		const bank = this.sfMatchGroupSum();
		const erp = this.round2(Number(candidate.row.amount));
		if (!candidate.exactAmount && Math.sign(bank) !== Math.sign(erp)) { return; }
		this.sfCompleteMatch(group.slice(), [candidate.row], !candidate.exactAmount);
	}

	sfSetHover(id: number): void {
		this.sfHoverLink = id > 0 ? id : 0;
		this.sfHoverFeed = id > 0 ? (this.sfMatchIdx[id] || null) : null;
	}

	/** Hovering a matched bank row lights up ALL of its ERP partners. */
	sfSetHoverBank(s: any): void {
		if (s && s.matched) {
			this.sfHoverFeed = s;
			this.sfHoverLink = Number(s.matchBankTransId) || 0;
		} else {
			this.sfHoverFeed = null;
			this.sfHoverLink = 0;
		}
	}

	sfBankHl(s: any): boolean {
		if (!s.matched) { return false; }
		if (this.sfHoverFeed === s) { return true; }
		return this.sfHoverLink > 0 && (s.matchList || []).some((m: any) => Number(m.banktransid) === this.sfHoverLink);
	}

	sfErpHl(t: any): boolean {
		const btid = this.bankTransId(t);
		if (!(btid > 0)) { return false; }
		if (this.sfHoverLink === btid) { return true; }
		return !!this.sfHoverFeed && (this.sfHoverFeed.matchList || []).some((m: any) => Number(m.banktransid) === btid);
	}

	/** Scroll the partner row into view and light the pair up. */
	sfJump(side: 'bank' | 'erp', id: number): void {
		if (!(id > 0)) { return; }
		// Reveal just the linked partner if a local filter/search excluded it. Keep
		// every operator-selected filter intact.
		this.sfRevealLink = id;
		this.sfSetHover(id);
		setTimeout(() => {
			const el = document.getElementById('sf-' + side + '-' + id);
			if (el) {
				el.scrollIntoView({ block: 'center', behavior: 'smooth' });
				return;
			}
			this.sf.message = 'The matched partner is outside the currently loaded date range. Expand the range and reload the ledger.';
		}, 50);
	}

	sfPairWith(s: any, t: any): void {
		this.sfCompleteMatch([s], [t]);
	}

	/** Undo a match: reset the feed row and un-clear its ERP partner(s) when possible. */
	sfUnmatch(s: any): void {
		const btids: number[] = (s.matchList || []).map((m: any) => Number(m.banktransid)).filter((n: number) => n > 0);
		s.matchList = [];
		s.matched = null;
		this.sfDeriveRowMatchFields(s);
		this.sfRebuildMatchIdx();
		// Sequenced, not fire-and-forget: updateBankRec now refuses to un-clear a row
		// that still has a match link, so the link has to be gone before the un-clear
		// is posted or the ERP side stays cleared with nothing pointing at it.
		this.paymentsService.simplefinUnmatch({ sf_account: s.sf_account, sf_id: s.sf_id }).subscribe(
			() => { this.sfUnclearAfterUnmatch(btids); },
			() => { this.sfUnclearAfterUnmatch(btids); }
		);
	}

	/** Un-clear the ERP partners of a match that has just been deleted. */
	private sfUnclearAfterUnmatch(btids: number[]): void {
		const rows = (this.payments && this.payments.transactions) ? this.payments.transactions : [];
		for (const btid of btids) {
			// A group's ERP posting can be shared by other bank lines — only
			// un-clear it once no remaining feed row still links to it.
			if (this.sfMatchIdx[btid]) { continue; }
			const t = rows.find((x: any) => this.bankTransId(x) === btid);
			if (t && t.isCleared && !t.clearedLocked) {
				t.isCleared = false;
				t.amountCleared = 0;
				this.paymentsService.updateTransaction(t).subscribe(
					(r: any) => {
						if (r) {
							t.isCleared = !!r.isCleared;
							t.amountCleared = r.amountCleared != null ? r.amountCleared : t.amountCleared;
						}
						this.applyFilters();
					},
					() => { this.applyFilters(); }
				);
			}
		}
	}

	/** Ignore = bank noise with no ERP counterpart; kept out of matching and totals. */
	sfToggleIgnore(s: any): void {
		s.ignored = !s.ignored;
		if (this.sfSelectedBank === s) { this.sfCloseMatch(); }
		if (s.ignored && this.sfIsBankSel(s)) { this.sfToggleBankSel(s); }
		this.paymentsService.simplefinSetIgnore({ sf_account: s.sf_account, sf_id: s.sf_id, ignored: !!s.ignored }).subscribe(() => {}, () => {});
	}

	/**
	 * AI matching for what auto-match left over. Sends the unmatched bank-feed rows
	 * and the clearable ERP rows to Claude, which proposes confident 1:1 matches
	 * (fee-adjusted amounts, fuzzy payee, wider date drift); confirmed rows clear.
	 */
	aiMatchSimplefin(): void {
		const account = String(this.selectedBankAccount.value || '');
		if (!account) { this.sf.message = 'Select a bank account on the Reconciliation tab first.'; return; }
		const sfLeft = (this.sf.transactions || []).filter((s: any) => String(s.erp_bankact) === account && !s.matched && !s.ignored && !s.feedPosted);
		const recRows = this.sfClearableRecRows();
		if (!sfLeft.length || !recRows.length) { this.sf.message = 'Nothing left for AI to match.'; return; }

		const sfRows = sfLeft.map((s: any) => ({
			sf_id: s.sf_id, posted: s.postedYmd || s.posted, amount: s.amount, description: s.description
		}));
		const bankRows = recRows.map((t: any) => ({
			transno: t.transno, trandate: t.trandateYmd || t.trandate, amount: parseFloat(t.amount),
			name: t.name || '', ref: t.reference || ''
		}));

		this.sfAiMatching = true;
		this.sf.message = '';
		this.paymentsService.simplefinAiMatch({ bankRows, sfRows }).subscribe(
			(res: any) => {
				this.sfAiMatching = false;
				if (!res || !res.success) { this.sf.message = (res && res.error) ? res.error : 'AI match failed.'; return; }
				const matches = Array.isArray(res.matches) ? res.matches : [];
				const toClear: any[] = [];
				const matchedRows: any[] = [];
				const usedBankTransIds = new Set<number>();
				for (const m of matches) {
					const s = sfLeft.find((x: any) => String(x.sf_id) === String(m.sf_id) && !x.matched);
					const t = recRows.find((x: any) => String(x.transno) === String(m.transno) && !x.isCleared && !x.clearedLocked && !usedBankTransIds.has(this.bankTransId(x)));
					if (s && t) {
						usedBankTransIds.add(this.bankTransId(t));
						this.sfApplyRowMatch(s, t, true, m.reason || '');
						toClear.push(t);
						// A subset-sum proposal settles several ERP receipts with one
						// deposit: attach each extra receipt (m.group) to the same feed
						// row. We already hold `s`, so applying more pairings past the
						// point sfApplyRowMatch flips s.matched=true is safe here.
						if (Array.isArray(m.group)) {
							for (const gt of m.group) {
								const gtRow = recRows.find((x: any) => String(x.transno) === String(gt) && !x.isCleared && !x.clearedLocked && !usedBankTransIds.has(this.bankTransId(x)));
								if (gtRow) {
									usedBankTransIds.add(this.bankTransId(gtRow));
									this.sfApplyRowMatch(s, gtRow, true, m.reason || '');
									toClear.push(gtRow);
								}
							}
						}
						matchedRows.push(s);
					}
				}
				this.sfRebuildMatchIdx();
				this.sf.message = 'AI matched ' + matchedRows.length + ', ' + this.sfUnmatchedCount() + ' still unmatched.';
				this.sfPersistMatches(matchedRows, 'ai');
				this.sfClearMatched(toClear);
			},
			() => { this.sfAiMatching = false; this.sf.message = 'AI match failed.'; }
		);
	}

	private sfFormatYmd(d: any): string {
		if (!d) { return ''; }
		const dt = (d instanceof Date) ? d : new Date(d);
		if (isNaN(dt.getTime())) { return ''; }
		const m = ('0' + (dt.getMonth() + 1)).slice(-2);
		const day = ('0' + dt.getDate()).slice(-2);
		return dt.getFullYear() + '-' + m + '-' + day;
	}

	back(): void {
		this.location.back();
	}
}
